var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// assets/polyfills.ts
var supported = typeof window === "undefined" ? true : "onscrollend" in window;
if (!supported) {
  let observe = function(proto, method, handler) {
    const native = proto[method];
    proto[method] = function() {
      const args = Array.prototype.slice.apply(arguments, [0]);
      native.apply(this, args);
      args.unshift(native);
      handler.apply(this, args);
    };
  }, onAddListener = function(originalFn, type, handler, options) {
    if (type != "scroll" && type != "scrollend") return;
    const scrollport = this;
    let data = observed.get(scrollport);
    if (data === void 0) {
      let timeout = 0;
      data = {
        scrollListener: /* @__PURE__ */ __name((evt) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            if (pointers.size) {
              setTimeout(data.scrollListener, 180);
            } else {
              if (scrollport) {
                scrollport.dispatchEvent(scrollendEvent);
              }
              timeout = 0;
            }
          }, 180);
        }, "scrollListener"),
        listeners: 0
        // Count of number of listeners.
      };
      originalFn.apply(scrollport, ["scroll", data.scrollListener]);
      observed.set(scrollport, data);
    }
    data.listeners++;
  }, onRemoveListener = function(originalFn, type, handler) {
    if (type != "scroll" && type != "scrollend") return;
    const scrollport = this;
    const data = observed.get(scrollport);
    if (data === void 0) return;
    data[type]--;
    if (--data.listeners > 0) return;
    originalFn.apply(scrollport, ["scroll", data.scrollListener]);
    observed.delete(scrollport);
  };
  observe2 = observe, onAddListener2 = onAddListener, onRemoveListener2 = onRemoveListener;
  __name(observe, "observe");
  __name(onAddListener, "onAddListener");
  __name(onRemoveListener, "onRemoveListener");
  const scrollendEvent = new Event("scrollend");
  const pointers = /* @__PURE__ */ new Set();
  document.addEventListener(
    "touchstart",
    (e) => {
      for (const touch of e.changedTouches) pointers.add(touch.identifier);
    },
    { passive: true }
  );
  document.addEventListener(
    "touchend",
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );
  document.addEventListener(
    "touchcancel",
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );
  const observed = /* @__PURE__ */ new WeakMap();
  observe(Element.prototype, "addEventListener", onAddListener);
  observe(window, "addEventListener", onAddListener);
  observe(document, "addEventListener", onAddListener);
  observe(Element.prototype, "removeEventListener", onRemoveListener);
  observe(window, "removeEventListener", onRemoveListener);
  observe(document, "removeEventListener", onRemoveListener);
}
var observe2;
var onAddListener2;
var onRemoveListener2;

// assets/search.ts
var initSearch = /* @__PURE__ */ __name(() => {
  const query = new URL(window.location.href).searchParams.get("q") ?? "";
  window.Alpine.store("search", {
    query
  });
  const searchStore = window.Alpine.store("search");
  Alpine.effect(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("q", searchStore.query);
    if (!searchStore.query) {
      url.searchParams.delete("q");
    }
    barba.history.add(url.toString(), "barba", "replace");
  });
  window.Alpine.magic("search", () => searchStore);
}, "initSearch");

// assets/accessibility.ts
var initAccessibility = /* @__PURE__ */ __name(() => {
  document.querySelectorAll(`[role="button"], [role="link"], [data-icon-handle]`).forEach((element) => {
    element.onkeydown = (event) => {
      if (element.role !== "link" && element.role !== "button") {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        element.dispatchEvent(new Event("click"));
      }
    };
  });
}, "initAccessibility");

// assets/collapsible.ts
var initCollapsible = /* @__PURE__ */ __name(($el, container, defaultOpen = false) => {
  const state = window.Alpine.reactive({
    open_accordion: defaultOpen,
    opening: false,
    closing: false,
    timeout: null,
    themeEditorControl: false
  });
  const toggleOpen = /* @__PURE__ */ __name((forceOpen = false, forceClose = false) => {
    if (state.themeEditorControl) return;
    clearTimeout(state.timeout);
    if ((!state.open_accordion || forceOpen) && !forceClose) {
      state.opening = true;
      state.closing = false;
      state.open_accordion = true;
      container.style.maxHeight = `${Math.max(container.scrollHeight + 15, 15)}px`;
      container.style.paddingTop = "";
      container.style.paddingBottom = "";
      [30, 60, 100, 150, 200].forEach((i) => {
        setTimeout(() => {
          if (state.opening && !state.closing) {
            container.style.maxHeight = `${Math.max(container.scrollHeight + 15, 15)}px`;
          }
        }, i);
      });
      state.timeout = setTimeout(() => {
        state.opening = false;
        container.style.maxHeight = `${Math.max(container.scrollHeight, 99999)}px`;
      }, 210);
      return;
    }
    if ((state.open_accordion || forceClose) && !forceOpen) {
      if (container.style.maxHeight === `99999px`) {
        container.classList.add("!transition-none");
        container.style.maxHeight = `${Math.max(container.scrollHeight + 15, 15)}px`;
      }
      Alpine.nextTick(() => {
        container.classList.remove("!transition-none");
        container.style.paddingTop = "0px";
        container.style.paddingBottom = "0px";
        container.style.maxHeight = `0px`;
        state.opening = false;
        state.closing = true;
      });
      state.timeout = setTimeout(() => {
        if (state.closing && !state.opening) {
          state.closing = false;
          state.open_accordion = false;
        }
      }, 210);
      return;
    }
  }, "toggleOpen");
  if (window.Shopify.designMode) {
    const editor = Alpine.store("editor");
    Alpine.effect(() => {
      const styleId = `${editor.select_section_id}--${editor.select_block_id}`;
      if ($el.getAttribute("data-style-id") === styleId || $el.parentElement.getAttribute("data-style-id") === styleId || $el.querySelector(`[data-style-id="${styleId}"]`)) {
        toggleOpen(true);
        state.themeEditorControl = true;
      } else {
        if (state.themeEditorControl) {
          state.themeEditorControl = false;
          toggleOpen(false, true);
        }
      }
    });
  }
  return {
    collapsible: state,
    toggleOpen
  };
}, "initCollapsible");

// assets/content-slider.ts
var getTransformedComputedStyle = /* @__PURE__ */ __name((element) => {
  const style = getComputedStyle(element);
  return {
    ...style,
    paddingLeft: parseFloat(style.paddingLeft?.replace("auto", "0")),
    paddingRight: parseFloat(style.paddingRight?.replace("auto", "0")),
    paddingTop: parseFloat(style.paddingTop?.replace("auto", "0")),
    paddingBottom: parseFloat(style.paddingBottom?.replace("auto", "0")),
    scrollPaddingLeft: parseFloat(style.scrollPaddingLeft?.replace("auto", "0")),
    scrollPaddingRight: parseFloat(style.scrollPaddingRight?.replace("auto", "0")),
    scrollPaddingTop: parseFloat(style.scrollPaddingTop?.replace("auto", "0")),
    scrollPaddingBottom: parseFloat(style.scrollPaddingBottom?.replace("auto", "0")),
    columnGap: parseFloat(style.columnGap?.replace("auto", "0")),
    rowGap: parseFloat(style.rowGap?.replace("auto", "0"))
  };
}, "getTransformedComputedStyle");
var initContentSlider = /* @__PURE__ */ __name(($el, container, speed = 200, infiniteScroll = false, autoRotate = 0, enable_mouse_dragging = false) => {
  if (!container) {
    container = $el.querySelector('[x-ref="scrollContainer"]') || $el.firstElementChild;
  }
  const isHorizontal = /* @__PURE__ */ __name(() => {
    return !!(getComputedStyle(container).overflowY === "hidden" || getComputedStyle(container).gridAutoFlow === "column" || container.scrollWidth > container?.clientWidth);
  }, "isHorizontal");
  const isScrollable = /* @__PURE__ */ __name(() => container.scrollWidth > container.clientWidth || container.scrollHeight > container.clientHeight, "isScrollable");
  const isDesktop = /* @__PURE__ */ __name(() => window.matchMedia("(min-width: 768px)").matches, "isDesktop");
  const shouldInfinite = /* @__PURE__ */ __name(() => {
    if (typeof infiniteScroll === "boolean") return infiniteScroll;
    switch (infiniteScroll) {
      case "all":
        return true;
      case "off":
        return false;
      case "desktop":
        return isDesktop();
      case "mobile":
        return !isDesktop();
      default:
        return false;
    }
  }, "shouldInfinite");
  const updateSliderHeightFromVisible = /* @__PURE__ */ __name(() => {
    container.style.setProperty("--slider-height", "0px");
    void container.offsetHeight;
    const trackRect = container.getBoundingClientRect();
    const all = Array.from(container.children);
    const candidates = state.infinite ? all.filter((el) => el.hasAttribute("data-original-node")) : all;
    const visible = candidates.filter((el) => {
      const r = el.getBoundingClientRect();
      return r.right > trackRect.left && r.left < trackRect.right && r.height > 0 && getComputedStyle(el).display !== "none";
    });
    const maxH = visible.reduce((m, el) => Math.max(m, el.getBoundingClientRect().height), 0);
    const finalH = Math.max(maxH, 1);
    container.style.setProperty("--slider-height", `${finalH}px`);
  }, "updateSliderHeightFromVisible");
  const random_id = utils.shortUUID();
  const containerStyles = getTransformedComputedStyle(container);
  const horizontal = isHorizontal();
  let breakPoints = [];
  let children = [...container.children].filter((el) => el.tagName !== "STYLE" && el.tagName !== "TEMPLATE").toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
  let size = children.length;
  const getChildSnapAlign = /* @__PURE__ */ __name((child, horizontal2) => {
    const rawSnapAlign = getComputedStyle(child).scrollSnapAlign?.trim();
    if (!rawSnapAlign || rawSnapAlign === "none") {
      return "start";
    }
    const [blockAlign, inlineAlign] = rawSnapAlign.split(/\s+/);
    const axisAlign = horizontal2 ? inlineAlign || blockAlign : blockAlign;
    if (axisAlign === "center" || axisAlign === "end") {
      return axisAlign;
    }
    return "start";
  }, "getChildSnapAlign");
  const getSnapPositionForChild = /* @__PURE__ */ __name((child, horizontal2) => {
    const containerStyles2 = getTransformedComputedStyle(container);
    const clientSpace = container?.[horizontal2 ? "clientWidth" : "clientHeight"];
    const scrollSpace = container?.[horizontal2 ? "scrollWidth" : "scrollHeight"];
    const maxScroll = Math.max(0, scrollSpace - clientSpace);
    const childStart = child?.[horizontal2 ? "offsetLeft" : "offsetTop"];
    const childSize = child?.[horizontal2 ? "offsetWidth" : "offsetHeight"];
    const scrollPaddingStart = horizontal2 ? containerStyles2.scrollPaddingLeft : containerStyles2.scrollPaddingTop;
    const scrollPaddingEnd = horizontal2 ? containerStyles2.scrollPaddingRight : containerStyles2.scrollPaddingBottom;
    const childAlign = getChildSnapAlign(child, horizontal2);
    let targetScroll = childStart - scrollPaddingStart;
    if (childAlign === "center") {
      targetScroll = childStart + childSize / 2 - (clientSpace + scrollPaddingStart - scrollPaddingEnd) / 2;
    }
    if (childAlign === "end") {
      targetScroll = childStart + childSize - clientSpace + scrollPaddingEnd;
    }
    return Math.max(0, Math.min(maxScroll, targetScroll));
  }, "getSnapPositionForChild");
  const usesCenteredSnap = /* @__PURE__ */ __name((elements, horizontal2) => {
    return elements.some((child) => getChildSnapAlign(child, horizontal2) === "center");
  }, "usesCenteredSnap");
  const calculateSlideCount = /* @__PURE__ */ __name((padding = state.horizontal ? state.paddingX : state.paddingY, gap = state.gap, scrollSpace = container[state.horizontal ? "scrollWidth" : "scrollHeight"], clientSpace = container?.[state.horizontal ? "clientWidth" : "clientHeight"]) => {
    const horizontal2 = isHorizontal();
    const containerStyles2 = getTransformedComputedStyle(container);
    if (scrollSpace <= clientSpace) {
      breakPoints = [0];
      return 1;
    }
    breakPoints = [];
    const snapToSlide = container.classList?.contains("snap-to-slide");
    let targetElements = [...container.children]?.slice(
      0,
      Math.ceil(
        container.children?.length / +(getComputedStyle(container).getPropertyValue(horizontal2 ? "grid-template-rows" : "grid-template-columns").split(" ").length ?? 1)
      )
    )?.filter(
      (child) => getComputedStyle(child).display !== "none" && (getComputedStyle(child).scrollSnapAlign !== "none" || snapToSlide)
    );
    targetElements = targetElements?.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (snapToSlide) {
      const gap2 = horizontal2 ? containerStyles2.columnGap : containerStyles2.rowGap;
      const paddingStart = horizontal2 ? containerStyles2.paddingLeft : containerStyles2.paddingTop;
      const newTargetElements = [];
      targetElements.forEach((el) => {
        el.style.scrollSnapAlign = "";
      });
      for (let i = 0; i < Math.ceil((scrollSpace - padding - (targetElements.length - 1) * gap2) / (clientSpace - padding)); i++) {
        const targetEl = targetElements.find(
          (el) => el[horizontal2 ? "offsetLeft" : "offsetTop"] - paddingStart >= i * (clientSpace - padding) + gap2 * i
        );
        if (targetEl) {
          targetEl.style.scrollSnapAlign = "start";
          newTargetElements.push(targetEl);
        }
      }
      targetElements = newTargetElements;
    }
    if (!Math.ceil((scrollSpace - padding) / (clientSpace - padding)) || Math.ceil(Math.round((scrollSpace - padding) / (clientSpace - padding) * 100) / 100) === Infinity) {
      return 0;
    }
    const breakPointIndex = [
      ...new Array(Math.ceil(Math.round((scrollSpace - padding) / (clientSpace - padding) * 100) / 100))
    ].reduce((acc, _, index) => {
      breakPoints[index] = (clientSpace - padding) * index + index * gap;
      if (!acc && (clientSpace - padding) * index + index * gap >= scrollSpace - padding) {
        breakPoints[index] = (clientSpace - padding) * index + (index - 1) * gap;
        return index;
      }
      return acc;
    }, 0);
    if (targetElements.length) {
      if (usesCenteredSnap(targetElements, horizontal2)) {
        breakPoints = targetElements.map((el) => getSnapPositionForChild(el, horizontal2));
        return breakPoints.length || 1;
      }
      const scrollPaddingStart = horizontal2 ? containerStyles2.scrollPaddingLeft : containerStyles2.scrollPaddingTop;
      const paddingEnd = horizontal2 ? containerStyles2.paddingRight : containerStyles2.paddingBottom;
      const maxScroll = scrollSpace - clientSpace;
      const lastElement = targetElements[targetElements.length - 1];
      const lastElementEnd = lastElement[horizontal2 ? "offsetLeft" : "offsetTop"] + lastElement[horizontal2 ? "offsetWidth" : "offsetHeight"];
      if (lastElementEnd <= clientSpace && maxScroll <= paddingEnd + 10) {
        return 1;
      }
      if (!snapToSlide) {
        const visibleArea = clientSpace - paddingEnd;
        let elementsFullyVisible = 0;
        for (const el of targetElements) {
          const elStart = el[horizontal2 ? "offsetLeft" : "offsetTop"] - scrollPaddingStart;
          const elEnd = elStart + el[horizontal2 ? "offsetWidth" : "offsetHeight"];
          const visiblePortion = Math.min(elEnd, visibleArea) - Math.max(elStart, 0);
          const elSize = el[horizontal2 ? "offsetWidth" : "offsetHeight"];
          if (elStart >= 0 && visiblePortion >= elSize * 0.8) {
            elementsFullyVisible++;
          }
        }
        const elementsOutside = targetElements.length - elementsFullyVisible;
        return elementsOutside > 0 ? elementsOutside + 1 : 1;
      }
      return targetElements.length;
    }
    return breakPointIndex || Math.ceil(Math.round((scrollSpace - padding) / (clientSpace - padding) * 100) / 100);
  }, "calculateSlideCount");
  const state = window.Alpine.reactive({
    random_id,
    autoRotate,
    container,
    rotateInterval: null,
    rotatePause: false,
    justify: containerStyles.justifyContent,
    current_index: 0,
    infinite: false,
    paddingX: containerStyles.paddingLeft + containerStyles.paddingRight,
    paddingY: containerStyles.paddingTop + containerStyles.paddingBottom,
    gap: (horizontal ? containerStyles.columnGap : containerStyles.rowGap) || 0,
    slide_count: calculateSlideCount(
      containerStyles[horizontal ? "paddingLeft" : "paddingTop"] + containerStyles[horizontal ? "paddingRight" : "paddingBottom"],
      horizontal ? containerStyles.columnGap : containerStyles.rowGap || 0,
      container?.[horizontal ? "scrollWidth" : "scrollHeight"],
      container?.[horizontal ? "clientWidth" : "clientHeight"]
    ),
    block_scroll_events: false,
    horizontal
  });
  const markCenteredChild = /* @__PURE__ */ __name((children2) => {
    const horizontal2 = isHorizontal();
    const centerX = container?.[horizontal2 ? "scrollLeft" : "scrollTop"] + container?.[horizontal2 ? "clientWidth" : "clientHeight"] / 2;
    let closest = null;
    let minDist = Infinity;
    children2.forEach((child) => {
      const center = child?.[horizontal2 ? "offsetLeft" : "offsetTop"] + child?.[horizontal2 ? "clientWidth" : "clientHeight"] / 2;
      const dist = Math.abs(center - centerX);
      if (dist < minDist) {
        minDist = dist;
        closest = child;
      }
    });
    children2.forEach((child) => {
      child.classList.toggle("centered", child === closest);
    });
  }, "markCenteredChild");
  const initInfiniteScroll = /* @__PURE__ */ __name((index = 0, force = false) => {
    children = [...container.children].filter((el) => el.tagName !== "STYLE" && el.tagName !== "TEMPLATE").toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    const containerStyles2 = getTransformedComputedStyle(container);
    size = children.filter((el) => el.hasAttribute("data-original-node"))?.length || children.length;
    if (!shouldInfinite() && state.infinite) {
      const originals = [...container.children];
      originals.forEach((el) => {
        if (!el.hasAttribute("data-original-node")) {
          el.remove();
        } else {
          el.style.order = "";
        }
      });
      state.infinite = false;
      children = [...container.children].filter((el) => el.tagName !== "STYLE" && el.tagName !== "TEMPLATE").toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    }
    if (shouldInfinite() && (!state.infinite || force)) {
      const visibleSpace = container.getBoundingClientRect()?.[horizontal ? "width" : "height"];
      const gapSize = containerStyles2?.[horizontal ? "columnGap" : "rowGap"] || 0;
      const totalContentSpace = [...container.children].filter((el) => el.tagName !== "STYLE" && el.tagName !== "TEMPLATE").reduce(
        (sum, child, index2) => sum + child.getBoundingClientRect()?.[horizontal ? "width" : "height"] + (index2 === 0 ? 0 : gapSize),
        0
      );
      if (totalContentSpace > visibleSpace) {
        state.infinite = true;
        const leftClones = 2 * size;
        children = [...new Array(size * 5)].map((_, idx) => {
          const order_index = idx - leftClones;
          const wrappedIdx = (order_index % size + size) % size;
          const original = children[wrappedIdx];
          if (order_index >= 0 && order_index < size) {
            original.style.order = `${order_index}`;
            original.setAttribute("data-original-node", "true");
            return original;
          }
          const newChild = original.cloneNode(true);
          newChild.style.order = `${order_index}`;
          newChild.removeAttribute("data-original-node");
          newChild.querySelectorAll("[x-defer-active]").forEach((el) => el.removeAttribute("x-defer-active"));
          newChild.removeAttribute("x-defer-active");
          container.append(newChild);
          return newChild;
        })?.sort((a, b) => +a.style.order - +b.style.order);
        if (container[horizontal ? "scrollWidth" : "scrollHeight"] < totalContentSpace) {
          requestAnimationFrame(() => {
            const containerStyles3 = getTransformedComputedStyle(container);
            const scrollPadding = containerStyles3[horizontal ? "scrollPaddingLeft" : "scrollPaddingTop"];
            container[horizontal ? "scrollLeft" : "scrollTop"] = children[leftClones + index]?.[horizontal ? "offsetLeft" : "offsetTop"] - scrollPadding;
            children.forEach((child) => {
              child.classList.toggle("scroll-active", +getComputedStyle(child).order === 0);
            });
          });
        } else {
          const scrollPadding = containerStyles2[horizontal ? "scrollPaddingLeft" : "scrollPaddingTop"];
          container[horizontal ? "scrollLeft" : "scrollTop"] = children[leftClones + index]?.[horizontal ? "offsetLeft" : "offsetTop"] - scrollPadding;
        }
      }
      children.forEach((child) => {
        child.classList.toggle("scroll-active", +getComputedStyle(child).order === 0);
      });
      markCenteredChild(children);
    }
    children.forEach((child, index2) => child.setAttribute("data-index", `${index2}`));
  }, "initInfiniteScroll");
  initInfiniteScroll();
  const handleInfiniteScroll = /* @__PURE__ */ __name(() => {
    if (state.block_scroll_events || !state.infinite) return;
    const containerStyles2 = getTransformedComputedStyle(container);
    container.parentElement.style.setProperty("--slider-height", `${container.offsetHeight}px`);
    container.parentElement.style.setProperty(
      "--slider-width",
      `${container?.clientWidth - containerStyles2.paddingLeft - containerStyles2.paddingRight}px`
    );
    children = [...children];
    const scrollKey = state.horizontal ? "scrollLeft" : "scrollTop";
    const currentScroll = container[scrollKey];
    const targetIndex = children.reduce(
      (best, child, index) => {
        const snapPos = getSnapPositionForChild(child, state.horizontal);
        const distance = Math.abs(snapPos - currentScroll);
        return distance < best.distance ? { index, distance } : best;
      },
      { index: -1, distance: Infinity }
    ).index;
    if (targetIndex === -1) return;
    const offsetKey = state.horizontal ? "offsetLeft" : "offsetTop";
    const target = children[targetIndex];
    const targetOffsetBefore = target[offsetKey];
    state.block_scroll_events = true;
    children = [...children].map((child, index) => {
      const targetOrder = index - targetIndex;
      child.style.order = targetOrder >= -2 * size && targetOrder < 3 * size ? `${targetOrder}` : targetOrder < -2 * size ? `${targetOrder + size * 5}` : `${targetOrder - size * 5}`;
      return child;
    })?.sort((a, b) => +a.style.order - +b.style.order);
    container[scrollKey] = currentScroll + (target[offsetKey] - targetOffsetBefore);
    Alpine.nextTick(() => {
      state.block_scroll_events = false;
      const children2 = [...container.children]?.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
      );
      if (state.infinite && children2?.length) {
        const targetIndex2 = children2?.findIndex((child) => +child.style.order === 0);
        state.current_index = targetIndex2 % size;
        children2.forEach((child, index) => {
          child.classList.toggle("scroll-active", index === targetIndex2);
        });
      }
    });
  }, "handleInfiniteScroll");
  const handleScroll = /* @__PURE__ */ __name(() => {
    if (state.block_scroll_events) return;
    if (state.infinite) {
      const containerStyles2 = getTransformedComputedStyle(container);
      container.parentElement.style.setProperty("--slider-height", `${container.offsetHeight}px`);
      container.parentElement.style.setProperty(
        "--slider-width",
        `${container?.clientWidth - containerStyles2.paddingLeft - containerStyles2.paddingRight}px`
      );
    }
    const currentIndex = breakPoints.findIndex(
      (num) => container[state.horizontal ? "scrollLeft" : "scrollTop"] >= num - 20 && container[state.horizontal ? "scrollLeft" : "scrollTop"] <= num + 20
    );
    const closest = breakPoints.reduce((acc, num) => {
      return Math.abs(num - container[state.horizontal ? "scrollLeft" : "scrollTop"]) < Math.abs(acc - container[state.horizontal ? "scrollLeft" : "scrollTop"]) ? num : acc;
    }, 0);
    const closestIndex = breakPoints.findIndex((num) => closest === num);
    const activeChildren = [...container.children]?.filter(
      (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
    );
    const sortedActiveChildren = activeChildren?.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (state.infinite && sortedActiveChildren?.length) {
      const targetIndex = sortedActiveChildren?.findIndex((child) => +child.style.order === 0);
      sortedActiveChildren.forEach((child, index) => {
        child.classList.toggle("scroll-active", index === targetIndex);
      });
      markCenteredChild(sortedActiveChildren);
      return;
    }
    if (sortedActiveChildren?.length) {
      if (usesCenteredSnap(sortedActiveChildren, state.horizontal)) {
        const scrollPosition = container[state.horizontal ? "scrollLeft" : "scrollTop"];
        const snapPositions = sortedActiveChildren.map((child) => getSnapPositionForChild(child, state.horizontal));
        breakPoints = [...snapPositions];
        const targetIndex2 = snapPositions.reduce((closestIndex2, position, index) => {
          const closestDistance = Math.abs(snapPositions[closestIndex2] - scrollPosition);
          const currentDistance = Math.abs(position - scrollPosition);
          return currentDistance < closestDistance ? index : closestIndex2;
        }, 0);
        state.current_index = targetIndex2;
        sortedActiveChildren.forEach((child, index) => {
          child.classList.toggle("scroll-active", index === state.current_index);
        });
        markCenteredChild(sortedActiveChildren);
        return;
      }
      if (container?.[state.horizontal ? "clientWidth" : "clientHeight"] + container[state.horizontal ? "scrollLeft" : "scrollTop"] + 10 >= container[state.horizontal ? "scrollWidth" : "scrollHeight"]) {
        state.current_index = state.slide_count - 1;
        markCenteredChild(sortedActiveChildren);
        return;
      }
      const style = window.getComputedStyle(container);
      const paddingStart = state.horizontal ? parseFloat(style.paddingLeft) || 0 : parseFloat(style.paddingTop) || 0;
      const scrollPos = container[state.horizontal ? "scrollLeft" : "scrollTop"];
      const triggerPos = scrollPos + paddingStart + 10;
      const targetIndex = sortedActiveChildren.findIndex((child) => {
        const start = child[state.horizontal ? "offsetLeft" : "offsetTop"];
        const end = start + child[state.horizontal ? "clientWidth" : "clientHeight"];
        return start <= triggerPos && end > triggerPos;
      });
      state.current_index = targetIndex === -1 ? state.current_index : targetIndex;
      sortedActiveChildren.forEach((child, index) => {
        child.classList.toggle("scroll-active", index === state.current_index);
      });
      markCenteredChild(sortedActiveChildren);
      return;
    }
    state.current_index = currentIndex !== -1 ? currentIndex : closestIndex !== -1 ? closestIndex : state.current_index;
    markCenteredChild(sortedActiveChildren);
  }, "handleScroll");
  const handleResize = /* @__PURE__ */ __name(() => {
    const { paddingLeft, paddingRight, paddingTop, paddingBottom, rowGap, columnGap } = getTransformedComputedStyle(container);
    state.paddingX = paddingLeft + paddingRight;
    state.paddingY = paddingTop + paddingBottom;
    state.horizontal = isHorizontal();
    state.gap = (state.horizontal ? columnGap : rowGap) || 0;
    state.slide_count = calculateSlideCount();
    initInfiniteScroll(state.current_index);
    container.classList.toggle("cursor-grab", enable_mouse_dragging && !state.infinite && isScrollable());
    if (state.justify === "center") {
      container.classList.toggle(
        "!justify-start",
        container[state.horizontal ? "scrollWidth" : "scrollHeight"] > container?.[state.horizontal ? "clientWidth" : "clientHeight"]
      );
      handleScroll();
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(updateSliderHeightFromVisible);
    });
  }, "handleResize");
  const scrollToIndex = /* @__PURE__ */ __name((index, scrollDuration = speed, force = false) => {
    if (!force && index === state.current_index) return;
    if (!state.infinite) {
      index = Math.max(0, Math.min(Math.max(0, state.slide_count - 1), index));
    }
    container.classList.remove("snap-both", "snap-x", "snap-y");
    const containerStyles2 = getTransformedComputedStyle(container);
    state.block_scroll_events = true;
    const activeChildren = [...container.children]?.filter(
      (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
    );
    const sortedActiveChildren = activeChildren?.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (sortedActiveChildren?.length) {
      const currentIndex = sortedActiveChildren.findIndex((child) => child.classList.contains("scroll-active"));
      if (state.infinite && currentIndex) {
        index = currentIndex - state.current_index + index;
      }
      const target = sortedActiveChildren[index];
      const centeredSnap = !!target && !state.infinite && getChildSnapAlign(target, state.horizontal) === "center";
      const targetX = state.horizontal && centeredSnap ? getSnapPositionForChild(target, true) : (target?.offsetLeft ?? 0) - containerStyles2.scrollPaddingLeft;
      const targetY = !state.horizontal && centeredSnap ? getSnapPositionForChild(target, false) : (target?.offsetTop ?? 0) - containerStyles2.scrollPaddingTop;
      sortedActiveChildren.forEach((child, i) => {
        child.classList.toggle("scroll-active", i === index);
      });
      utils.scrollToXY(scrollDuration, targetX, targetY, container, () => {
        container.classList.add(state.horizontal ? "snap-x" : "snap-y");
        state.block_scroll_events = false;
        handleScroll();
        if (state.infinite) {
          handleInfiniteScroll();
        }
      });
      return;
    }
    utils.scrollToXY(
      scrollDuration,
      (container?.clientWidth - state.paddingX) * index + index * state.gap,
      (container?.clientHeight - state.paddingY) * index + index * state.gap,
      container,
      () => {
        container.classList.add(state.horizontal ? "snap-x" : "snap-y");
        state.block_scroll_events = false;
        handleScroll();
      }
    );
  }, "scrollToIndex");
  if (state.justify === "center") {
    container.classList.toggle(
      "!justify-start",
      container[state.horizontal ? "scrollWidth" : "scrollHeight"] > container?.[state.horizontal ? "clientWidth" : "clientHeight"]
    );
    state.paddingX = containerStyles.paddingLeft + containerStyles.paddingRight;
    state.paddingY = containerStyles.paddingTop + containerStyles.paddingBottom;
    state.horizontal = isHorizontal();
    state.gap = (state.horizontal ? containerStyles.columnGap : containerStyles.rowGap) || 0;
    state.slide_count = calculateSlideCount();
    handleScroll();
  }
  if (autoRotate) {
    Alpine.effect(() => {
      if (!autoRotate) return;
      if (!state.rotateInterval && !state.rotatePause) {
        state.rotateInterval = setInterval(() => {
          if (state.infinite) {
            const target = [...container.children]?.find((child) => +getComputedStyle(child).order === 1);
            if (target) {
              container.classList.remove("snap-both", "snap-x", "snap-y");
              const containerStyles2 = getTransformedComputedStyle(container);
              state.block_scroll_events = true;
              utils.scrollToXY(
                speed,
                (target?.offsetLeft ?? 0) - containerStyles2.scrollPaddingLeft,
                (target?.offsetTop ?? 0) - containerStyles2.scrollPaddingTop,
                container,
                () => {
                  container.classList.add(state.horizontal ? "snap-x" : "snap-y");
                  state.block_scroll_events = false;
                  handleScroll();
                  if (state.infinite) {
                    handleInfiniteScroll();
                  }
                }
              );
              return;
            }
          }
          scrollToIndex(state.current_index + 1 >= state.slide_count ? 0 : state.current_index + 1);
        }, autoRotate * 1e3);
      }
      if (state.rotateInterval && state.rotatePause) {
        clearInterval(state.rotateInterval);
        state.rotateInterval = null;
      }
    });
  }
  container.classList.add(state.horizontal ? "snap-x" : "snap-y");
  if (enable_mouse_dragging) {
    const enableDragScroll = /* @__PURE__ */ __name((container2) => {
      let isDragging = false;
      let dragged = false;
      let startX, startY, scrollLeft, scrollTop;
      container2.classList.toggle("cursor-grab", enable_mouse_dragging && !state.infinite && isScrollable());
      const deactivateCursor = /* @__PURE__ */ __name(() => {
        container2.classList.remove("cursor-grab");
      }, "deactivateCursor");
      const addDraggingCursor = /* @__PURE__ */ __name(() => {
        document.body.classList.add("dragging");
      }, "addDraggingCursor");
      const removeDraggingCursor = /* @__PURE__ */ __name(() => {
        document.body.classList.remove("dragging");
      }, "removeDraggingCursor");
      const smoothSnapToClosestChild = /* @__PURE__ */ __name(() => {
        const children2 = Array.from(container2.children);
        if (!children2.length) return;
        const horizontal2 = container2.scrollWidth > container2.clientWidth;
        const style = getComputedStyle(container2);
        const padStart = horizontal2 ? parseFloat(style.paddingLeft) || 0 : parseFloat(style.paddingTop) || 0;
        const scrollPos = horizontal2 ? container2.scrollLeft : container2.scrollTop;
        const snapStart = /* @__PURE__ */ __name((el) => (horizontal2 ? el.offsetLeft : el.offsetTop) - padStart, "snapStart");
        let closest = null;
        let minDist = Infinity;
        for (const child of children2) {
          const start = snapStart(child);
          const dist = Math.abs(start - scrollPos);
          if (dist < minDist) {
            minDist = dist;
            closest = child;
          }
        }
        if (!closest) return;
        const targetPos = snapStart(closest);
        container2.scrollTo({
          [horizontal2 ? "left" : "top"]: targetPos,
          behavior: "smooth"
        });
        setTimeout(() => {
          container2.style.scrollSnapType = "";
        }, 400);
      }, "smoothSnapToClosestChild");
      const onMouseDown = /* @__PURE__ */ __name((e) => {
        if (state.infinite || document.body.classList.contains("dragging")) return;
        if (!isScrollable()) return;
        isDragging = true;
        dragged = false;
        startX = e.pageX - container2.offsetLeft;
        startY = e.pageY - container2.offsetTop;
        scrollLeft = container2.scrollLeft;
        scrollTop = container2.scrollTop;
        addDraggingCursor();
        container2.style.scrollSnapType = "none";
        e.preventDefault();
      }, "onMouseDown");
      const onMouseMove = /* @__PURE__ */ __name((e) => {
        if (!isDragging) return;
        dragged = true;
        const x = e.pageX - container2.offsetLeft;
        const y = e.pageY - container2.offsetTop;
        const walkX = (x - startX) * 1.5;
        const walkY = (y - startY) * 2;
        container2.scrollLeft = scrollLeft - walkX;
        container2.scrollTop = scrollTop - walkY;
      }, "onMouseMove");
      const onMouseUp = /* @__PURE__ */ __name(() => {
        if (!isDragging) return;
        isDragging = false;
        removeDraggingCursor();
        if (dragged) {
          smoothSnapToClosestChild();
        } else {
          container2.style.scrollSnapType = "";
        }
      }, "onMouseUp");
      const onClickCapture = /* @__PURE__ */ __name((e) => {
        if (dragged) {
          e.stopPropagation();
          e.preventDefault();
          dragged = false;
        }
      }, "onClickCapture");
      container2.addEventListener("mousedown", onMouseDown);
      window.addEventListener("mousemove", onMouseMove, true);
      window.addEventListener("mouseup", onMouseUp, true);
      container2.addEventListener("click", onClickCapture, true);
      const ro = new ResizeObserver(() => {
        if (isScrollable()) {
          container2.classList.toggle("cursor-grab", enable_mouse_dragging && !state.infinite && isScrollable());
        } else {
          deactivateCursor();
        }
      });
      ro.observe(container2);
      const mo = new MutationObserver(() => {
        if (isScrollable()) {
          container2.classList.toggle("cursor-grab", enable_mouse_dragging && !state.infinite && isScrollable());
        } else {
          deactivateCursor();
        }
      });
      mo.observe(container2, { childList: true, subtree: true });
    }, "enableDragScroll");
    enableDragScroll(container);
  }
  Alpine.nextTick(() => {
    handleResize();
    handleScroll();
    handleInfiniteScroll();
  });
  const resizeObserver = new ResizeObserver(() => {
    handleResize();
    handleScroll();
    handleInfiniteScroll();
  });
  resizeObserver.observe(container);
  return {
    content_slider: {
      container,
      state,
      handleInfiniteScroll,
      handleScroll,
      handleResize,
      scrollToIndex,
      calculateSlideCount,
      initInfiniteScroll
    }
  };
}, "initContentSlider");

// assets/utils.ts
var JSONParse = /* @__PURE__ */ __name((object, origin = "") => {
  if (object === void 0) {
    return null;
  }
  try {
    return JSON.parse(object);
  } catch (err) {
    return null;
  }
}, "JSONParse");
var getImageSrcSet = /* @__PURE__ */ __name((src, maxWidth) => {
  if (!src) {
    return "";
  }
  if (src.includes("?")) {
    return [48, 96, 256, 384, 460, 640, 960, 1200, 1440, 1920, 3840].map((number, index, arr) => {
      if (maxWidth && arr[index - 1] > maxWidth) {
        return null;
      }
      return `${src}&width=${number} ${number}w`;
    })?.filter((d) => !!d).join(",");
  }
  return [48, 96, 256, 384, 460, 640, 960, 1200, 1440, 1920, 3840].map((number, index, arr) => {
    if (maxWidth && arr[index - 1] > maxWidth) {
      return null;
    }
    return `${src}?width=${number} ${number}w`;
  })?.filter((d) => !!d).join(",");
}, "getImageSrcSet");
var getReviewStarGradients = /* @__PURE__ */ __name((rating, position) => {
  return `url(#star-rating-${rating < position - 1 ? 0 : rating < position && rating > position - 1 ? Math.floor((rating - (position - 1)) * 100 / 25) * 25 : 100})`;
}, "getReviewStarGradients");
var pushSearchParams = /* @__PURE__ */ __name(({
  update = {},
  remove = [],
  title
}) => {
  const url = new URL(window.location.href);
  Object.entries(update).forEach(([key, value]) => {
    url.searchParams.set(key, `${value}`);
  });
  remove.forEach((key) => {
    url.searchParams.delete(key);
  });
  window.history.pushState(null, null, url);
}, "pushSearchParams");
var replaceSearchParams = /* @__PURE__ */ __name(({
  update = {},
  remove = [],
  title
}) => {
  const url = new URL(window.location.href);
  Object.entries(update).forEach(([key, value]) => {
    url.searchParams.set(key, `${value}`);
  });
  remove.forEach((key) => {
    url.searchParams.delete(key);
  });
  window.history.replaceState(null, null, url);
}, "replaceSearchParams");
var getSiblingUrl = /* @__PURE__ */ __name((handle) => {
  const url = new URL(window.location.href);
  url.pathname = /\/collections\/[^/]\/products\//gi.test(url.pathname) ? url.pathname.replace(/\/products\/[^?]*/gi, `/products/${handle}`) : `/products/${handle}`;
  url.searchParams.delete("variant");
  url.searchParams.delete("selling_plan");
  return url.toString();
}, "getSiblingUrl");
var pushUrlTarget = /* @__PURE__ */ __name((id) => {
  const url = new URL(window.location.href);
  url.hash = id;
  window.history.replaceState(null, null, url);
}, "pushUrlTarget");
var checkDomain = /* @__PURE__ */ __name(function(url) {
  if (url && url?.indexOf("//") === 0) {
    url = location.protocol + url;
  }
  return url.toLowerCase().replace(/([a-z])?:\/\//, "$1").split("/")[0];
}, "checkDomain");
var isExternalURL = /* @__PURE__ */ __name(function(url) {
  if (!url || typeof url !== "string") {
    return false;
  }
  return (url?.indexOf(":") > -1 || url?.indexOf("//") > -1) && checkDomain(location.href) !== checkDomain(url);
}, "isExternalURL");
var transpileRichtextMetafield = /* @__PURE__ */ __name((schema) => {
  function convertSchemaToHtml(schema2) {
    let html = ``;
    if (!Array.isArray(schema2) && schema2.type === "root") {
      html += convertSchemaToHtml(schema2.children);
    }
    if (Array.isArray(schema2)) {
      schema2?.forEach((el) => {
        switch (el.type) {
          case "paragraph":
            html += buildParagraph(el);
            break;
          case "heading":
            html += buildHeading(el);
            break;
          case "list":
            html += buildList(el);
            break;
          case "list-item":
            html += buildListItem(el);
            break;
          case "link":
            html += buildLink(el);
            break;
          case "text":
            html += buildText(el);
            break;
          default:
            break;
        }
      });
    }
    return html;
  }
  __name(convertSchemaToHtml, "convertSchemaToHtml");
  function buildParagraph(el) {
    if (el?.children) {
      return `<p>${convertSchemaToHtml(el?.children)}</p>`;
    }
    return "";
  }
  __name(buildParagraph, "buildParagraph");
  function buildHeading(el) {
    if (el?.children) {
      return `<h${el?.level}>${convertSchemaToHtml(el?.children)}</h${el?.level}>`;
    }
    return "";
  }
  __name(buildHeading, "buildHeading");
  function buildList(el) {
    if (el?.children) {
      if (el?.listType === "ordered") {
        return `<ol>${convertSchemaToHtml(el?.children)}</ol>`;
      } else {
        return `<ul>${convertSchemaToHtml(el?.children)}</ul>`;
      }
    }
    return "";
  }
  __name(buildList, "buildList");
  function buildListItem(el) {
    if (el?.children) {
      return `<li>${convertSchemaToHtml(el?.children)}</li>`;
    }
    return "";
  }
  __name(buildListItem, "buildListItem");
  function buildLink(el) {
    return `<a href="${el?.url}" title="${el?.title}" target="${el?.target}">${convertSchemaToHtml(el?.children)}</a>`;
  }
  __name(buildLink, "buildLink");
  function buildText(el) {
    if (el?.bold) {
      return `<strong>${el?.value}</strong>`;
    }
    if (el?.italic) {
      return `<em>${el?.value}</em>`;
    }
    return el?.value;
  }
  __name(buildText, "buildText");
  return convertSchemaToHtml(schema);
}, "transpileRichtextMetafield");
var clsx = /* @__PURE__ */ __name((...props) => {
  let i = 0;
  let tmp;
  let str = "";
  const len = props.length;
  for (; i < len; i++) {
    if (tmp = props[i]) {
      if (typeof tmp === "string") {
        str += (str && " ") + tmp;
      }
    }
  }
  return str;
}, "clsx");
var shortUUID = /* @__PURE__ */ __name(() => {
  let firstPart = Math.random() * 46656 | 0;
  let secondPart = Math.random() * 46656 | 0;
  firstPart = `000${firstPart.toString(36)}`.slice(-3);
  secondPart = `000${secondPart.toString(36)}`.slice(-3);
  return firstPart + secondPart;
}, "shortUUID");
var isEmail = /* @__PURE__ */ __name((str) => {
  if (!str) return false;
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
}, "isEmail");
var formatMoney = /* @__PURE__ */ __name((cents, money_format, no_rounding = true) => {
  if (!cents && cents !== 0) {
    return "";
  }
  function n(t, e) {
    return void 0 === t ? e : t;
  }
  __name(n, "n");
  function o(t, e, o2, i2) {
    if (e = n(e, 2), o2 = n(o2, ","), i2 = n(i2, "."), isNaN(t) || null === t) return 0;
    const r2 = (t = (t / 100).toFixed(e)).split(".");
    return r2[0].replace(/(\\d)(?=(\\d\\d\\d)+(?!\\d))/g, `$1${o2}`) + (r2[1] ? i2 + r2[1] : "");
  }
  __name(o, "o");
  "string" === typeof cents && (cents = cents.replace(".", ""));
  let i = "";
  const r = /{{\s*(\w+)\s*}}/;
  const a = money_format || window.money_format || `\${{amount}}`;
  switch (a.match(r)[1]) {
    case "amount":
      i = o(cents, 2);
      break;
    case "amount_no_decimals": {
      if (no_rounding && +cents % 100 > 0) {
        i = o(cents, 2);
        break;
      }
      i = o(cents, 0);
      break;
    }
    case "amount_with_comma_separator":
      i = o(cents, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      i = o(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      i = o(cents, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      i = o(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      i = o(cents, 2, "'", ".");
  }
  return a.replace(r, i);
}, "formatMoney");
window["formatMoney"] = formatMoney;
var roundToIndex = /* @__PURE__ */ __name(function(x, index = 0) {
  const power = Math.pow(10, -index);
  return Math.round(x * power) / power;
}, "roundToIndex");
var easeInOutQuad = /* @__PURE__ */ __name(({ currentTime, start, change, duration }) => {
  let newCurrentTime = currentTime;
  newCurrentTime /= duration / 2;
  if (newCurrentTime < 1) {
    return change / 2 * newCurrentTime * newCurrentTime + start;
  }
  newCurrentTime -= 1;
  return -change / 2 * (newCurrentTime * (newCurrentTime - 2) - 1) + start;
}, "easeInOutQuad");
var scrollToY = /* @__PURE__ */ __name((duration, to, container = window, callback = () => {
}) => {
  const start = container instanceof HTMLElement ? container.scrollTop : container.scrollY;
  const change = to - start;
  const startDate = (/* @__PURE__ */ new Date()).getTime();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = (/* @__PURE__ */ new Date()).getTime();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      0,
      easeInOutQuad({
        currentTime,
        start,
        change,
        duration
      })
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(0, to);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToY");
var scrollToX = /* @__PURE__ */ __name((duration, to, container = window, callback = () => {
}) => {
  const start = container instanceof HTMLElement ? container.scrollLeft : container.scrollX;
  const change = to - start;
  const startDate = (/* @__PURE__ */ new Date()).getTime();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = (/* @__PURE__ */ new Date()).getTime();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      easeInOutQuad({
        currentTime,
        start,
        change,
        duration
      }),
      0
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(to, 0);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToX");
var scrollToXY = /* @__PURE__ */ __name((duration, x, y, container = window, callback = () => {
}) => {
  const startX = container instanceof HTMLElement ? container.scrollLeft : container.scrollX;
  const startY = container instanceof HTMLElement ? container.scrollTop : container.scrollY;
  const changeX = x - startX;
  const changeY = y - startY;
  const startDate = Date.now();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = Date.now();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      easeInOutQuad({
        currentTime,
        start: startX,
        change: changeX,
        duration
      }),
      easeInOutQuad({
        currentTime,
        start: startY,
        change: changeY,
        duration
      })
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(x, y);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToXY");
var isElementScrollable = /* @__PURE__ */ __name((element) => {
  if (!element) return false;
  const { overflowX, overflowY } = getComputedStyle(element);
  const isScrollableX = element.scrollWidth > element.clientWidth && overflowX !== "visible";
  const isScrollableY = element.scrollHeight > element.clientHeight && overflowY !== "visible";
  return isScrollableX || isScrollableY;
}, "isElementScrollable");
function getElementPosition(element) {
  const box = element.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top: Math.round(top), left: Math.round(left) };
}
__name(getElementPosition, "getElementPosition");
var getElementOffset = /* @__PURE__ */ __name((el) => {
  const rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}, "getElementOffset");
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
__name(delay, "delay");
var debounce = /* @__PURE__ */ __name((callback, wait = 1) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}, "debounce");
var findAllScrollableParents = /* @__PURE__ */ __name((element) => {
  const scrollableParents = [];
  let parent = element.parentElement;
  while (parent) {
    const style = window.getComputedStyle(parent);
    const overflowY = style.getPropertyValue("overflow-y");
    if (overflowY === "auto" || overflowY === "scroll") {
      scrollableParents.push(parent);
    }
    parent = parent.parentElement;
  }
  if (document.scrollingElement) {
    scrollableParents.push(document.scrollingElement);
  }
  scrollableParents.push(window);
  return scrollableParents;
}, "findAllScrollableParents");
var handlelize = /* @__PURE__ */ __name((str) => {
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/([^\w]+|\s+)/g, "-").replace(/--+/g, "-").replace(/(^-+|-+$)/g, "").toLowerCase();
  return str;
}, "handlelize");
var serializeForm = /* @__PURE__ */ __name((formElement) => {
  const obj = {};
  const formData = new FormData(formElement);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return obj;
}, "serializeForm");
var deepEqual = /* @__PURE__ */ __name((a, b) => {
  if (a === b) return true;
  if (a && b && typeof a === "object" && typeof b === "object") {
    if (a.constructor !== b.constructor) return false;
    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) if (!deepEqual(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }
  return a !== a && b !== b;
}, "deepEqual");
window.clsx = clsx;
var isVisible = /* @__PURE__ */ __name((elem, isParent = false) => {
  if (!(elem instanceof Element)) {
    return false;
  }
  const style = getComputedStyle(elem);
  if (style.display === "none") return false;
  if (!isParent && style.pointerEvents === "none") return false;
  if (style.visibility !== "visible") return false;
  if (+style.opacity < 0.1) return false;
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) {
    return false;
  }
  if (elem.parentElement) {
    return isVisible(elem.parentElement, true);
  }
  return true;
}, "isVisible");
var isInViewport = /* @__PURE__ */ __name((element) => {
  const { y } = element.getBoundingClientRect();
  if (y > window.innerHeight || y < 0) {
    return false;
  }
  return true;
}, "isInViewport");
var getBracketInputDynamicText = /* @__PURE__ */ __name((content, object = {}) => {
  let returnValue = "";
  returnValue = content?.replace(/\[([^\]]*)\]/gi, (...matches) => {
    if (!matches[1]) {
      return "";
    }
    if (/^icon\./gi.test(matches[1])) {
      return matches[0];
    }
    let result = (
      // @ts-ignore
      matches?.[1]?.split(".")?.reduce(
        (acc, selector, index, arr) => {
          if (!selector || acc[0] === void 0 || acc[0] === null) {
            if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
              return [utils2.formatMoney(acc[0]), selector];
            }
            if (/_at$/gi.test(acc[1]) && Date.parse(acc[0])) {
              return [new Date(acc[0]).toLocaleDateString(), selector];
            }
            if (typeof acc[0] === "string" && acc[0].includes("\xAE")) {
              return [acc[0].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
            }
            if (Array.isArray(acc[0]) && acc[0].every((val) => typeof val === "string" || typeof val === "number")) {
              return [acc[0].join(", "), selector];
            }
            return acc;
          }
          if (acc[0] && typeof acc[0] === "object" && selector in acc[0]) {
            if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
              return [utils2.formatMoney(acc[0][selector]), selector];
            }
            if (/_at$/gi.test(selector) && Date.parse(acc[0][selector])) {
              if (arr[index + 1]) {
                return [window.dayjs(acc[0][selector])?.format(arr[index + 1]), selector];
              }
              return [new Date(acc[0][selector]).toLocaleDateString(), selector];
            }
            if (typeof acc[0][selector] === "string" && acc[0][selector].includes("\xAE")) {
              return [acc[0][selector].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
            }
            if (index === arr.length - 1) {
              if (Array.isArray(acc[0][selector]) && acc[0][selector].every((val) => typeof val === "string" || typeof val === "number")) {
                return [acc[0][selector].join(", "), selector];
              }
            }
            return [acc[0][selector], selector];
          }
          if (selector && typeof acc[0] === "string") {
            return acc;
          }
          return ["", ""];
        },
        [object, ""]
      )?.[0] ?? ""
    );
    if (typeof result === "string" && result?.includes("Default Title")) {
      result = result?.replace("Default Title", "");
    }
    return result;
  }) ?? "";
  return returnValue;
}, "getBracketInputDynamicText");
var getBracketInputDynamicValue = /* @__PURE__ */ __name((content, object = {}) => {
  let returnValue = null;
  if (!content || typeof content !== "string") {
    return null;
  }
  content?.replace(/\[([^\]]*)\]/gi, (...matches) => {
    if (!matches[1]) {
      return returnValue;
    }
    returnValue = matches?.[1]?.split(".")?.reduce(
      (acc, selector) => {
        if (!selector || acc[0] === void 0 || acc[0] === null) {
          if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
            return [utils2.formatMoney(acc[0]), selector];
          }
          if (/_at$/gi.test(acc[1]) && Date.parse(acc[0])) {
            return [new Date(acc[0]).toLocaleDateString(), selector];
          }
          if (typeof acc[0] === "string" && acc[0].includes("\xAE")) {
            return [acc[0].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
          }
          return acc;
        }
        if (acc[0] && selector in acc[0]) {
          if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
            return [utils2.formatMoney(acc[0][selector]), selector];
          }
          if (/_at$/gi.test(selector) && Date.parse(acc[0][selector])) {
            return [new Date(acc[0][selector]).toLocaleDateString(), selector];
          }
          if (typeof acc[0][selector] === "string" && acc[0][selector].includes("\xAE")) {
            return [acc[0][selector].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
          }
          return [acc[0][selector], selector];
        }
        return ["", ""];
      },
      [object, ""]
    )?.[0];
    return "";
  });
  return returnValue ?? "";
}, "getBracketInputDynamicValue");
function unescape(htmlStr) {
  htmlStr = htmlStr.replace(/&lt;/g, "<");
  htmlStr = htmlStr.replace(/&gt;/g, ">");
  htmlStr = htmlStr.replace(/&quot;/g, '"');
  htmlStr = htmlStr.replace(/&#39;/g, "'");
  htmlStr = htmlStr.replace(/&amp;/g, "&");
  return htmlStr;
}
__name(unescape, "unescape");
function setUniformHeightById(id) {
  const elements = document.querySelectorAll(`[data-style-id="${id}"]`);
  if (elements.length === 0) {
    return;
  }
  let maxHeight = 0;
  elements.forEach((element) => {
    element.style.height = "auto";
    const elementHeight = element.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });
  elements.forEach((element) => {
    element.style.height = `${maxHeight}px`;
  });
}
__name(setUniformHeightById, "setUniformHeightById");
var setCookie = /* @__PURE__ */ __name((cookieName, cookieValue, cookieMinutes = 60 * 24) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  const d = /* @__PURE__ */ new Date();
  d.setTime(d.getTime() + cookieMinutes * 60 * 1e3);
  const expires = d.toUTCString();
  document.cookie = `${cookieName}=${cookieValue};expires=${expires};path=/;SameSite=Strict;`;
  return true;
}, "setCookie");
var getCookie = /* @__PURE__ */ __name((cookieName) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  const name = `${cookieName}=`;
  const cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return false;
}, "getCookie");
var checkCookie = /* @__PURE__ */ __name((cookieName) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  return !!cookieName && document.cookie.includes(`${cookieName}=`);
}, "checkCookie");
var removeCookie = /* @__PURE__ */ __name((cookieName) => {
  setCookie(cookieName, "", -1);
}, "removeCookie");
var focusSelectorString = `:not(.placeholder) a[href]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) button:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) textarea:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="text"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="radio"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="checkbox"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) select:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder, [tabindex="-1"]) [tabindex]:not(:where([disabled],[tabindex="-1"])`;
var calculateHeaderHeight = /* @__PURE__ */ __name(() => {
  document.body.style.setProperty(
    "--header-height-offset",
    `${utils2.roundToIndex(document.querySelector("[data-navigation-bar]")?.getBoundingClientRect().bottom, -2)}px`
  );
}, "calculateHeaderHeight");
var initYouTube = /* @__PURE__ */ __name(async () => {
  if (!window.YT && !window._youtube_initialized) {
    window._youtube_initialized = true;
    await new Promise((resolve) => {
      if (!window.onYouTubeIframeAPIReady) {
        window.onYouTubeIframeAPIReady = () => {
          resolve(true);
          document.dispatchEvent(new CustomEvent("youtube-loaded"));
        };
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
    });
  }
}, "initYouTube");
var simulateAnchorTag = /* @__PURE__ */ __name(($el) => {
  if (!$el) return;
  const modalStore = window.Alpine.store("modal");
  $el.addEventListener("click", (e) => {
    if (e.target.closest("a") || !$el.getAttribute("data-href")) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.button === 1 || e.ctrlKey || e.metaKey) {
      window.open($el.getAttribute("data-href"), "_blank", "noopener,noreferrer");
    } else if (e.shiftKey) {
      window.open($el.getAttribute("data-href"), "_blank");
    } else {
      barba.go($el.getAttribute("data-href"));
      modalStore.setId("");
    }
  });
  $el.addEventListener("mousedown", (e) => {
    if (e.target.closest("a") || !$el.getAttribute("data-href")) return;
    if (e.button === 1 || e.ctrlKey || e.metaKey) {
      window.open($el.getAttribute("data-href"), "_blank", "noopener,noreferrer");
      e.preventDefault();
    }
  });
  $el.addEventListener("keydown", (e) => {
    if (!$el.getAttribute("data-href")) return;
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      barba.go($el.getAttribute("data-href"));
      modalStore.setId("");
    }
  });
}, "simulateAnchorTag");
var preloadImage = /* @__PURE__ */ __name((src) => {
  if (!src) return true;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}, "preloadImage");
var utils2 = {
  initCollapsible,
  initContentSlider,
  initYouTube,
  simulateAnchorTag,
  clsx,
  getImageSrcSet,
  JSONParse,
  getSiblingUrl,
  calculateHeaderHeight,
  unescape,
  preloadImage,
  setCookie,
  getCookie,
  checkCookie,
  removeCookie,
  isVisible,
  isInViewport,
  getReviewStarGradients,
  transpileRichtextMetafield,
  handlelize,
  delay,
  debounce,
  scrollToY,
  scrollToX,
  scrollToXY,
  isElementScrollable,
  checkDomain,
  isExternalURL,
  getElementPosition,
  getBracketInputDynamicText,
  getBracketInputDynamicValue,
  deepEqual,
  getElementOffset,
  shortUUID,
  serializeForm,
  roundToIndex,
  formatMoney,
  findAllScrollableParents,
  isEmail,
  pushSearchParams,
  replaceSearchParams,
  pushUrlTarget,
  setUniformHeightById,
  focusSelectorString
};
var utils_default = utils2;

// assets/cart.ts
var initCart = /* @__PURE__ */ __name(() => {
  window.Alpine.store("cart", {
    history: [structuredClone(window._cart_data)],
    state: {
      ...window._cart_data,
      items: window._cart_data?.items.map((item, index) => ({ ...item, index })) ?? []
    },
    upsell_products: [],
    gift_products: [],
    loading: false,
    isChanging: false,
    debounce_updates: []
  });
  const cart = window.Alpine.store("cart");
  window.Alpine.magic("cart", () => cart);
  window._stores["cart"] = cart;
  window._cart_data = cart.state;
  const get = /* @__PURE__ */ __name(async (productAdded = false) => {
    const data = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ sections: "data_cart_json" })
    }).then((res) => res.json()).catch((e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      cart.isChanging = false;
      return window._stores["cart"].state;
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      cart.isChanging = false;
      return window._stores["cart"].state;
    }
    const item_components = utils.JSONParse(
      data.sections?.data_cart_json?.replace(`<div id="shopify-section-data_cart_json" class="shopify-section">`, "")?.replace(/<\/div>[\s\n]*$/gi, "") ?? "[]"
    );
    const newCartData = {
      ...data,
      items: data?.items.map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      })) ?? [],
      item_count: data.items?.filter((item) => !item?.properties?._p_id_link)?.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    if (productAdded) {
      document.dispatchEvent(new CustomEvent("productAddedToCart", { detail: newCartData }));
    }
    return newCartData;
  }, "get");
  const add = /* @__PURE__ */ __name(async (cartItems) => {
    cart.isChanging = true;
    const data = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(cartItems)
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return {
        ...await get(),
        cart_error: true
      };
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return {
        ...await get(),
        cart_error: true
      };
    }
    return await get(true);
  }, "add");
  const update = /* @__PURE__ */ __name(async (updates) => {
    cart.isChanging = true;
    const data = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...updates, sections: "data_cart_json" })
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const item_components = utils.JSONParse(
      data.sections?.data_cart_json?.replace(`<div id="shopify-section-data_cart_json" class="shopify-section">`, "")?.replace(/<\/div>[\s\n]*$/gi, "") ?? "[]"
    );
    const newCartData = {
      ...data,
      items: data?.items.map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      })) ?? [],
      item_count: data.items?.filter((item) => !item?.properties?._p_id_link)?.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "update");
  const change = /* @__PURE__ */ __name(async (cartItem) => {
    cart.isChanging = true;
    const data = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...cartItem, sections: "data_cart_json" })
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    console.log({ data });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const item_components = utils.JSONParse(
      data.sections?.data_cart_json?.replace(`<div id="shopify-section-data_cart_json" class="shopify-section">`, "")?.replace(/<\/div>[\s\n]*$/gi, "") ?? "[]"
    );
    const { items_added, items_removed, ...cart_data } = data;
    const newCartData = {
      ...cart_data,
      items: cart_data?.items.map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      })) ?? [],
      item_count: data.items?.filter((item) => !item?.properties?._p_id_link)?.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "change");
  const clear = /* @__PURE__ */ __name(async () => {
    const data = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const newCartData = {
      ...data,
      items: [],
      item_count: 0
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "clear");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "always": {
        return true;
      }
      case "cart_empty": {
        return !cart.state.item_count;
      }
      case "items_added": {
        return !!cart.state.item_count;
      }
    }
  }, "showConditionally");
  const updateLineItemQuantity = /* @__PURE__ */ __name((quantity, index) => {
    if (!cart.state.items[index] || cart.state.items[index]?.quantity === quantity || cart.state.items.length !== _stores.cart?.history[0].items.length) {
      return;
    }
    cart.state.items[index].quantity = Math.max(0, quantity);
    cart.state.item_count = cart.state.items?.filter((item) => !item?.properties?._p_id_link)?.reduce((acc, item) => acc += item.quantity, 0);
    cart.state.total_price = cart.state.items.reduce((acc, item) => acc += item.price * item.quantity, 0);
    cart.debounce_updates = cart.state.items.map((item) => item.quantity);
  }, "updateLineItemQuantity");
  const renderDynamicProductCards = /* @__PURE__ */ __name(async ($el, target_product, primary_source, secondary_source, product_class, limit, hide_if_empty, content_slider) => {
    const fallback_products = utils.JSONParse($el.getAttribute("data-fallback-products"));
    content_slider?.handleResize();
    setTimeout(() => {
      content_slider?.handleResize();
    }, 50);
    const lineItemProducts = await Promise.all(
      cart.state.items?.map((item) => _product.getHydratedProductData(item.handle, item.product_id))
    );
    const products = [];
    const complementary_products = [];
    const related_products = [];
    switch (target_product) {
      case "ai": {
        const expensive = [...cart.state.items].sort((a, b) => b.final_price - a.final_price).slice(0, 3);
        const recent = cart.state.items.slice(0, 2).sort((a, b) => b.final_price - a.final_price);
        [...recent, ...expensive]?.forEach((line, parentIndex) => {
          const product = lineItemProducts.find((p) => p.handle === line.handle);
          product?.complementary_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            complementary_products.push(item);
          });
          product?.related_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            related_products.push(item);
          });
        });
        break;
      }
      case "most_expensive": {
        [...cart.state.items].sort((a, b) => b.final_price - a.final_price)?.forEach((line, parentIndex) => {
          const product = lineItemProducts.find((p) => p.handle === line.handle);
          product?.complementary_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            complementary_products.push(item);
          });
          product?.related_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            related_products.push(item);
          });
        });
        break;
      }
      case "least_expensive": {
        [...cart.state.items].sort((a, b) => a.final_price - b.final_price)?.forEach((line, parentIndex) => {
          const product = lineItemProducts.find((p) => p.handle === line.handle);
          product?.complementary_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            complementary_products.push(item);
          });
          product?.related_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            related_products.push(item);
          });
        });
        break;
      }
      case "recently_added": {
        cart.state.items?.forEach((line, parentIndex) => {
          const product = lineItemProducts.find((p) => p.handle === line.handle);
          product?.complementary_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            complementary_products.push(item);
          });
          product?.related_products?.forEach((item, i) => {
            if (i >= 2 || i >= 1 && parentIndex >= 2) {
              return;
            }
            related_products.push(item);
          });
        });
        break;
      }
    }
    switch (primary_source) {
      case "complementary": {
        complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (window?._recent_products ?? [])?.map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (window?._recent_products ?? []).map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    const controlProducts = products?.filter((prod) => !cart.state.items.some((item) => item.product_id === prod.id))?.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i) ?? [];
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        $el.closest(`.shopify-section`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "container":
        $el.closest(`[data-style-id]:not([data-style-id="${$el.getAttribute("data-style-id")}"])`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "block":
        $el?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
    }
    const renderProducts = controlProducts?.filter(
      (prod, index) => prod.handle !== $el.children?.[index]?.getAttribute("data-product-handle")
    );
    cart.upsell_products = controlProducts;
    if (!renderProducts.length) {
      return;
    }
    $el.innerHTML = "";
    controlProducts.slice(0, limit).forEach((prod, i, arr) => {
      const node = document.querySelector(`[data-product-card='${product_class}']`)?.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute("class", `shrink-0 max-w-full w-full h-full`);
        node?.removeAttribute(`data-product-card`);
        node?.setAttribute("data-product-handle", prod.handle);
        node?.setAttribute("data-product-id", `${prod.id}`);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        $el.appendChild(div);
      }
    });
  }, "renderDynamicProductCards");
  const renderGiftProducts = /* @__PURE__ */ __name(async ($el, target_type, target, receives_quantity, allow_duplicates, product_class, hide_if_empty, content_slider) => {
    const products = utils.JSONParse($el.getAttribute("data-gift-products"));
    content_slider?.handleResize();
    setTimeout(() => {
      content_slider?.handleResize();
    }, 50);
    const controlProducts = cart.state[target_type] >= target && cart?.state?.items?.reduce(
      (acc, lineItem) => products.some((prod) => prod.id === lineItem.product_id) ? acc += lineItem.quantity : acc,
      0
    ) < receives_quantity ? products?.filter((prod) => allow_duplicates || !cart.state.items.some((item) => item.product_id === prod.id))?.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i) : [];
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        $el.closest(`.shopify-section`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "container":
        $el.closest(`[data-style-id]:not([data-style-id="${$el.getAttribute("data-style-id")}"])`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "block":
        $el?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
    }
    const renderProducts = controlProducts?.filter(
      (prod, index) => prod.handle !== $el.children?.[index]?.getAttribute("data-product-handle")
    );
    cart.gift_products = controlProducts;
    if (!renderProducts.length) {
      return;
    }
    $el.innerHTML = "";
    controlProducts.forEach((prod, i, arr) => {
      const node = document.querySelector(`[data-product-card='${product_class}']`)?.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute("class", `shrink-0 max-w-full w-full h-full`);
        node?.removeAttribute(`data-product-card`);
        node?.setAttribute("data-product-handle", prod.handle);
        node?.setAttribute("data-product-id", `${prod.id}`);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        $el.appendChild(div);
      }
    });
  }, "renderGiftProducts");
  const getDynamicTextWithFormattedPrice = /* @__PURE__ */ __name((content) => {
    return content?.replace(/\[([^\]]*)\]/gi, (...matches) => {
      return matches?.[1]?.split(".").reduce(
        (acc, selector) => {
          if (!selector || acc[0] === void 0 || acc[0] === null) {
            if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
              return [formatMoney(acc[0]), selector];
            }
            return acc;
          }
          if (acc[0] && selector in acc[0]) {
            if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
              return [formatMoney(acc[0][selector]), selector];
            }
            return [acc[0][selector], selector];
          }
          return ["", ""];
        },
        [{ cart: cart.state }, ""]
      )[0];
    }) ?? "";
  }, "getDynamicTextWithFormattedPrice");
  const debounceCartUpdates = window.Alpine.debounce(async () => {
    const b = cart.history[0]?.items.map((item) => item.quantity);
    if (!utils.deepEqual(b, cart.debounce_updates) && cart.debounce_updates.length) {
      cart.loading = true;
      await update({ updates: cart.debounce_updates });
      cart.debounce_updates = [];
      cart.loading = false;
    }
    cart.loading = false;
  }, 650);
  window.Alpine.effect(() => {
    cart.state.item_count = cart.state.items?.filter((item) => !item?.properties?._p_id_link)?.reduce((acc, item) => acc += item.quantity, 0);
    window._cart_data = cart.state;
  });
  window.Alpine.effect(() => {
    cart.state.original_pre_selling_plan_total_price = cart.state.items?.reduce((acc, item) => {
      acc += item.quantity * (item?.selling_plan_allocation?.compare_at_price ?? item?.original_price);
      return acc;
    }, 0);
    cart.state.selling_plan_discount_applications = cart.state?.items?.reduce((acc, item) => {
      if (!item?.selling_plan_allocation?.selling_plan?.name) {
        return acc;
      }
      const index = acc.findIndex((selling_plan) => selling_plan.name === item?.selling_plan_allocation?.selling_plan?.name);
      if (index !== -1) {
        acc[index].value += (item?.selling_plan_allocation?.compare_at_price - item?.selling_plan_allocation?.price) * item?.quantity;
        return acc;
      }
      acc.push({
        name: item?.selling_plan_allocation?.selling_plan?.name,
        value: (item?.selling_plan_allocation?.compare_at_price - item?.selling_plan_allocation?.price) * item?.quantity
      });
      return acc;
    }, []);
  });
  window.Alpine.effect(() => {
    if (cart.debounce_updates.length) {
      debounceCartUpdates();
    }
  });
  document.addEventListener("productAddedToCart", async (event) => {
    const updatedCart = cart.state;
    if (typeof window._learnq !== "undefined") {
      const cartData = {
        total_price: updatedCart.total_price / 100,
        $value: updatedCart.total_price / 100,
        total_discount: updatedCart.total_discount,
        original_total_price: updatedCart.original_total_price / 100,
        items: updatedCart.items
      };
      window._learnq.push(["track", "Added to Cart", cartData]);
    }
  });
  window._cart = {
    add,
    get,
    update,
    change,
    clear,
    showConditionally,
    updateLineItemQuantity,
    renderDynamicProductCards,
    getDynamicTextWithFormattedPrice,
    renderGiftProducts
  };
  return {
    add,
    get,
    update,
    change,
    clear,
    showConditionally,
    updateLineItemQuantity,
    renderDynamicProductCards,
    getDynamicTextWithFormattedPrice,
    renderGiftProducts
  };
}, "initCart");

// assets/media-gallery.ts
var initMediaGallery = /* @__PURE__ */ __name(() => {
  window.Alpine.store("mediaGallery", {
    show: false,
    media: _products[Object.keys(_products)[0]]?.media ?? [],
    index: 0,
    scrollIndex: 0,
    showGallery({ media = [], index = 0 }) {
      this.media = media;
      this.show = true;
      this.index = index;
      this.scrollIndex = index;
    }
  });
  const mediaGalleryStore = window.Alpine.store("mediaGallery");
  Alpine.effect(() => {
    if (!mediaGalleryStore.show && mediaGalleryStore.media.length) {
      mediaGalleryStore.media = [];
    }
  });
  window.Alpine.magic("mediaGallery", () => mediaGalleryStore);
  window._stores["mediaGallery"] = mediaGalleryStore;
}, "initMediaGallery");

// assets/modals.ts
var initModals = /* @__PURE__ */ __name(() => {
  const modalsContainer = document.querySelector("[data-dynamic-modals]");
  window.Alpine.store("modal", {
    id: "",
    loaded: !!modalsContainer?.children.length || window.modalsLoaded,
    setId(value) {
      this.id = value;
    }
  });
  const modalStore = window.Alpine.store("modal");
  window.Alpine.magic("modal", () => modalStore);
  window._stores["modal"] = modalStore;
  const handleKeydown = /* @__PURE__ */ __name((e) => {
    if (e.key === "Escape") {
      modalStore.setId("");
    }
  }, "handleKeydown");
  window.Alpine.effect(() => {
    const blockScroll = modalStore?.id && !/^megamenu--/gi.test(modalStore?.id) && modalStore?.id !== "search" && modalStore?.id !== "account_menu";
    document.body.classList.toggle("!overflow-hidden", blockScroll);
    document.documentElement.classList.toggle("!overflow-hidden", blockScroll);
    if (modalStore?.id) {
      document.addEventListener("keydown", handleKeydown);
    }
    if (!modalStore?.id) {
      document.removeEventListener("keydown", handleKeydown);
    }
  });
  const initEvents = /* @__PURE__ */ __name((target = document) => {
    target.querySelectorAll(
      `[href*="#modal--"], [href*="#popup--"], [href*="#drawer--"], [href*="#megamenu--"]`
    ).forEach((link) => {
      const handle = link.href?.replace(/.*?#/gi, "")?.split("?")?.[0] ?? "";
      link.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (modalStore.id === handle) {
          modalStore.setId("");
          return;
        }
        modalStore.setId(handle);
      };
      const handleFocusKeydown = /* @__PURE__ */ __name((e) => {
        if (modalStore.id === handle && (e.key === " " || e.key === "Enter" || e.key === "ArrowUp")) {
          modalStore.setId("");
          return;
        }
        if (e.key === " " || e.key === "Enter" || e.key === "ArrowDown") {
          modalStore.setId(handle);
        }
      }, "handleFocusKeydown");
      link.onfocus = (e) => {
        link.addEventListener("keydown", handleFocusKeydown);
      };
      link.onblur = (e) => {
        link.removeEventListener("keydown", handleFocusKeydown);
      };
    });
  }, "initEvents");
  const editor = window.Alpine.store("editor");
  window.Alpine.effect(() => {
    if (editor?.load_section_id) {
      initEvents();
    }
  });
  const mutationObserver = new MutationObserver((e) => {
    e?.forEach((record) => {
      const nodes = [];
      if (record?.addedNodes?.length && record?.target instanceof Element) {
        initEvents(record.target);
      }
    });
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  initEvents();
}, "initModals");

// assets/page-transitions.ts
var startTime = Date.now();
var initialized = false;
var firstRender = true;
var initPageTransitions = /* @__PURE__ */ __name(() => {
  if (initialized) return;
  const rootContainer = document.querySelector("[data-content-root]");
  const scrollToTarget = /* @__PURE__ */ __name(() => {
    if (window.location.hash) {
      const target = document?.querySelector(window.location.hash);
      if (!target) return;
      if (utils.isElementScrollable(target.parentElement) && utils.isVisible(target.parentElement) && utils.isInViewport(target)) {
        if (target.parentElement.scrollWidth > target.parentElement.offsetWidth) {
          utils.scrollToXY(260, target.offsetLeft, target.parentElement?.scrollTop, target.parentElement);
        }
        if (target.parentElement.scrollHeight > target.parentElement.offsetHeight) {
          utils.scrollToXY(260, target.parentElement?.scrollLeft, target.offsetTop, target.parentElement);
        }
        return;
      }
      const targetPosition = utils.getElementPosition(target)?.top - Math.max(0, document.querySelector(".header-sections-container")?.getBoundingClientRect()?.bottom ?? 0);
      utils.scrollToY(260 + Math.abs(Math.round((window.scrollY - targetPosition) / 15)), targetPosition);
    }
  }, "scrollToTarget");
  window.Alpine.store("router", {
    pathname: rootContainer.getAttribute("data-pathname"),
    template: rootContainer.getAttribute("data-template"),
    hash: window.location.hash,
    setValue(key, value) {
      this[key] = value;
    }
  });
  const routerStore = window.Alpine.store("router");
  window.Alpine.magic("router", () => routerStore);
  window._stores["router"] = routerStore;
  window.Alpine.effect(() => {
  });
  if (window.design_mode || !window.page_transitions_enabled) {
    barba.go = (href) => {
      if (typeof href === "string" && window.location.href !== href) {
        window.location.href = href;
      }
    };
    barba.prefetch = () => {
    };
  }
  barba.use(barbaPrefetch, {
    root: document.body,
    timeout: 4e3,
    /* @ts-ignore */
    limit: 0
  });
  document.addEventListener("barba:prefetch:fulfilled", async (e) => {
    if (typeof idbKeyval !== "undefined" && !window.design_mode) {
      requestIdleCallback(
        async () => {
          const url = e.detail.url?.replace(/(\/collections\/[^/]*\/)/gi, "/");
          const fetchResults = await barba.cache.get(url).request.then((res) => ({ data: res }));
          const div = document.createElement("div");
          div.innerHTML = fetchResults?.data?.html;
          const productData = div.querySelectorAll(`[data-product-data]`);
          productData?.forEach(async (scriptElement) => {
            const product = utils.JSONParse(scriptElement.innerHTML);
            if (product?.handle) {
              const dbKey = `_${window.Shopify.theme.id}-product--${product.handle}`;
              _products[product.handle] = {
                recommendations_loaded_at: 0,
                related_products: [],
                complementary_products: [],
                ...await idbKeyval?.get(dbKey) || {},
                ..._products[product.handle] ?? {},
                ...product,
                updated_at: Date.now()
              };
              await idbKeyval.set(dbKey, _products[product.handle]);
            }
          });
          await idbKeyval.set(`barba-prefetch---${startTime}-//-${url}`, fetchResults);
        },
        { timeout: 3e3 }
      );
    }
  });
  if (typeof idbKeyval !== "undefined" && window.theme_settings && !window.design_mode) {
    idbKeyval.keys().then(async (res) => {
      res.forEach(async (key) => {
        const [timestamp, cacheKey] = key.replace("barba-prefetch---", "").split("-//-");
        if (cacheKey && +timestamp > Date.now() - 1e3 * 60 * 10) {
          barba.cache.set(
            cacheKey,
            idbKeyval.get(key).then((res2) => res2.data),
            "prefetch"
          );
        } else if (cacheKey && +timestamp > 0) {
          idbKeyval.del(key);
        }
      });
      await delay(100);
      barba.timeout = window.origin.includes("127.0.0.1") ? 3e4 : 4e3;
    }).catch(async (err) => {
      await delay(100);
      barba.timeout = window.origin.includes("127.0.0.1") ? 3e4 : 4e3;
    });
  }
  const transitionOverlay = document.querySelector("[data-transition-overlay]");
  barba.init({
    prefetchIgnore: [
      "/challenge",
      "/gift_cards",
      "/search",
      "/account",
      "/account/:any",
      "/customer_identity",
      "/customer_identity/:any",
      "/apps",
      "/apps/:any",
      "/cart",
      ...window.page_transitions_ignore ?? []
    ].filter(Boolean),
    cacheIgnore: [
      "/challenge",
      "/gift_cards",
      "/search",
      "/account",
      "/account/:any",
      "/customer_identity",
      "/customer_identity/:any",
      "/apps",
      "/apps/:any",
      "/cart",
      ...window.page_transitions_ignore ?? []
    ].filter(Boolean),
    debug: true,
    /* @ts-ignore */
    cacheFirstPage: true,
    timeout: window.origin.includes("127.0.0.1") ? 3e4 : 4e3,
    // default is 2000ms,
    transitions: [
      {
        name: "opacity-transition",
        leave: /* @__PURE__ */ __name((data) => {
          transitionOverlay.classList.add("active", "out-active");
        }, "leave"),
        enter: /* @__PURE__ */ __name((data) => {
          const handleTransitionend = /* @__PURE__ */ __name(() => {
            transitionOverlay.classList.remove("out-active");
            transitionOverlay.removeEventListener("transitionend", handleTransitionend);
          }, "handleTransitionend");
          transitionOverlay.classList.remove("active");
          transitionOverlay.addEventListener("transitionend", handleTransitionend);
          window.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }, "enter")
      }
    ],
    views: [
      {
        beforeLeave: /* @__PURE__ */ __name((data) => {
          console.debug("beforeLeave", data);
          window._stores?.modal?.setId("");
        }, "beforeLeave"),
        namespace: "tmp",
        afterLeave(data) {
          console.debug("afterLeave", data);
          routerStore.setValue(
            "pathname",
            window.location.pathname
            /*data.next.container.getAttribute("data-pathname")*/
          );
          if (!data?.next?.container) {
            return;
          }
          routerStore.setValue("template", data?.next?.container?.getAttribute("data-template"));
        },
        beforeEnter: /* @__PURE__ */ __name((data) => {
          console.debug("beforeEnter", data);
        }, "beforeEnter"),
        afterEnter: /* @__PURE__ */ __name((data) => {
          console.debug("afterEnter", data);
          data?.current?.container?.remove();
          window._stores["quickView"].show = false;
          window._stores?.modal?.setId("");
          const productDataContainer = data.next.container?.querySelector("[data-product-data-init]");
          if (productDataContainer) {
            const newScriptTag = document.createElement("script");
            newScriptTag.innerHTML = productDataContainer.innerText;
            newScriptTag.setAttribute("data-product-data-init", "");
            document.head.appendChild(newScriptTag);
          }
          if (data?.next?.container && !firstRender) {
            utils.delay(60).then(() => {
              scrollToTarget();
              const html = document.createElement("html");
              html.innerHTML = data.next?.html;
              html.querySelectorAll(".shopify-block.shopify-app-block").forEach((element) => {
                const currentElement = document.getElementById(element.id);
                currentElement.parentNode.replaceChild(element, currentElement);
              });
              const contentScripts = html.querySelectorAll("[data-content-root] script[src]");
              html.querySelectorAll(":not([data-content-root]) script[src]").forEach((scriptElement) => {
                const existingScript = document.head.querySelector(`script[src*="${scriptElement.src.split("?")[0]?.split("/").at(-1)}"]`) || [...contentScripts].includes(scriptElement);
                if (!existingScript) {
                  const newScriptTag = document.createElement("script");
                  scriptElement.getAttributeNames().forEach((name) => {
                    newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                    if (name === "src") {
                      newScriptTag.setAttribute(
                        name,
                        scriptElement.src?.includes("?") ? `${scriptElement?.src}&v_id=${Date.now()}` : `${scriptElement?.src}?v_id=${Date.now()}`
                      );
                    }
                  });
                  document.head.appendChild(newScriptTag);
                }
              });
              document.querySelectorAll(
                "[data-content-root] script:not(script[src],[data-product-data],[type='application/json'])"
              ).forEach((scriptElement) => {
                const newScriptTag = document.createElement("script");
                newScriptTag.innerHTML = scriptElement.innerHTML;
                scriptElement.getAttributeNames().forEach((name) => {
                  newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                  if (name === "src") {
                    newScriptTag.setAttribute(
                      name,
                      scriptElement.src?.includes("?") ? `${scriptElement?.src}&v_id=${Date.now()}` : `${scriptElement?.src}?v_id=${Date.now()}`
                    );
                  }
                });
                scriptElement.parentNode.replaceChild(newScriptTag, scriptElement);
              });
              document.querySelectorAll("[data-content-root] script[src]").forEach((scriptElement) => {
                const newScriptTag = document.createElement("script");
                scriptElement.getAttributeNames().forEach((name) => {
                  newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                  if (name === "src") {
                    newScriptTag.setAttribute(
                      name,
                      scriptElement.src?.includes("?") ? `${scriptElement?.src}&v_id=${Date.now()}` : `${scriptElement?.src}?v_id=${Date.now()}`
                    );
                  }
                });
                scriptElement.parentNode.replaceChild(newScriptTag, scriptElement);
              });
            });
          }
          if (!firstRender) {
            document.dispatchEvent(new Event("DOMContentLoaded"));
            window.dispatchEvent(new Event("DOMContentLoaded"));
            document.dispatchEvent(new CustomEvent("pageFullyLoaded", {}));
            Shopify?.PaymentButton?.init();
            window?.okeWidgetApi?.initAllWidgets();
            window?.yotpoWidgetsContainer?.initWidgets();
            setTimeout(() => {
              window?.okeWidgetApi?.initAllWidgets();
            }, 1e3);
            setTimeout(() => {
              window?.okeWidgetApi?.initAllWidgets();
            }, 3e3);
          }
          firstRender = false;
        }, "afterEnter")
      }
    ]
  });
  barba.timeout = 1;
  initialized = true;
}, "initPageTransitions");

// assets/pagination.ts
var initPagination = /* @__PURE__ */ __name(() => {
}, "initPagination");
var _pagination = {
  init: /* @__PURE__ */ __name((paginationContainer, container) => {
    const paginateToUrl = /* @__PURE__ */ __name(async (url) => {
      if (!container) {
        return;
      }
      try {
        container?.querySelectorAll(
          "[class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--]"
        )?.forEach((card) => {
          card?.classList?.add("button-loading-transparent");
        });
        const html = await fetch(url).then((res) => res.text());
        const newDocument = new DOMParser().parseFromString(html, "text/html");
        const newContent = newDocument.querySelector(
          `[data-next-url][x-ref="${container?.getAttribute("x-ref")}"]`
        );
        const newPagination = newDocument.querySelector(`[data-pagination][x-ref="pagination"]`);
        if (newContent) {
          container.innerHTML = newContent.innerHTML;
        }
        if (newPagination) {
          paginationContainer.innerHTML = newPagination.innerHTML;
        }
        window.scrollTo({
          top: container?.getBoundingClientRect().y + window.scrollY - 260,
          behavior: "smooth"
        });
        barba.history.add(url.toString(), "barba", "replace");
      } catch (error) {
        console.error("Error loading new page:", error);
      }
    }, "paginateToUrl");
    return {
      paginateToUrl
    };
  }, "init")
};
window._pagination = _pagination;

// assets/product-data.ts
var _product2 = {
  hydrateProduct: /* @__PURE__ */ __name(async (product) => {
    if (!product?.handle && !product?.id) return null;
    if ((_products[product.handle]?.recommendations_loaded_at ?? 0) > Date.now() - 1e3 * 60 * 30) {
      return _products[product.handle];
    }
    const dbKey = `_${window.Shopify.theme.id}-product--${product.handle}`;
    const data = await idbKeyval.get(dbKey);
    _products[product.handle] = {
      recommendations_loaded_at: 0,
      related_products: [],
      complementary_products: [],
      ...data || {},
      ...product,
      updated_at: Date.now()
    };
    if (!data || (data.recommendations_loaded_at ?? 0) < Date.now() - 1e3 * 60 * 30) {
      const [related_products, complementary_products] = await Promise.all([
        fetch(
          `/recommendations/products?product_id=${product.id}&limit=10&section_id=data_product_json&intent=related`
        ).then((res) => res.text()).then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          return utils.JSONParse(
            html.querySelector("[data-product-recommendations]")?.innerHTML ?? "[]"
          );
        }),
        fetch(
          `/recommendations/products?product_id=${product.id}&limit=10&section_id=data_product_json&intent=complementary`
        ).then((res) => res.text()).then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          return utils.JSONParse(
            html.querySelector("[data-product-recommendations]")?.innerHTML ?? "[]"
          );
        })
      ]);
      _products[product.handle] = {
        ..._products[product.handle],
        related_products,
        complementary_products,
        recommendations_loaded_at: Date.now(),
        updated_at: Date.now()
      };
      requestIdleCallback(
        async () => {
          await idbKeyval.set(dbKey, _products[product.handle]);
          [...related_products ?? [], ...complementary_products ?? []].filter((a, i, arr) => arr.findIndex((b) => a.handle === b.handle) === i).map(async (product2) => {
            const dbKey2 = `_${window.Shopify.theme.id}-product--${product2.handle}`;
            _products[product2.handle] = {
              recommendations_loaded_at: 0,
              related_products: [],
              complementary_products: [],
              ...await idbKeyval?.get(dbKey2) || {},
              ...product2,
              updated_at: Date.now()
            };
            idbKeyval?.set(dbKey2, _products[product2.handle]);
          });
        },
        { timeout: 5e3 }
      );
    }
    return _products[product.handle];
  }, "hydrateProduct"),
  getHtmlProduct: /* @__PURE__ */ __name((handle) => {
    const product = JSONParse(
      document.querySelector(`[data-product-data="${handle}"]`)?.innerHTML
    );
    if (product) {
      _products[handle] = {
        recommendations_loaded_at: 0,
        complementary_products: [],
        related_products: [],
        ..._products[handle] ?? {},
        ...product,
        updated_at: Date.now()
      };
      _product2.saveProduct(handle);
      return _products[handle];
    }
    return null;
  }, "getHtmlProduct"),
  getCachedProduct: /* @__PURE__ */ __name(async (handle) => {
    const dbKey = `_${window.Shopify.theme.id}-product--${handle}`;
    const product = await idbKeyval.get(dbKey);
    if (product && (product.updated_at ?? 0) > Date.now() - 1e3 * 60 * 30) {
      _products[handle] = {
        ..._products[handle] ?? {},
        ...product
      };
      return _products[handle];
    }
    return null;
  }, "getCachedProduct"),
  getFetchProduct: /* @__PURE__ */ __name(async (handle, productId) => {
    if (!productId) return null;
    try {
      const product = await fetch(
        `/recommendations/products?product_id=${productId}&limit=10&section_id=data_product_json&intent=related&with_product_data=true`
      ).then((res) => res.text()).then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const product2 = utils.JSONParse(
          html.querySelector("[data-product-data]")?.innerHTML ?? "{}"
        );
        product2.related_products = utils.JSONParse(
          html.querySelector("[data-product-recommendations]")?.innerHTML ?? "[]"
        );
        requestIdleCallback(
          async () => {
            [...product2.related_products ?? []].filter((a, i, arr) => arr.findIndex((b) => a.handle === b.handle) === i).map(async (product3) => {
              const dbKey = `_${window.Shopify.theme.id}-product--${product3.handle}`;
              _products[product3.handle] = {
                recommendations_loaded_at: 0,
                related_products: [],
                complementary_products: [],
                ...await idbKeyval?.get(dbKey) || {},
                ...product3,
                updated_at: Date.now()
              };
              idbKeyval?.set(dbKey, _products[product3.handle]);
            });
          },
          { timeout: 5e3 }
        );
        product2.recommendations_loaded_at = Date.now();
        return product2;
      });
      if (product) {
        _products[handle] = {
          recommendations_loaded_at: 0,
          complementary_products: [],
          related_products: [],
          ..._products[handle] ?? {},
          ...product,
          updated_at: Date.now()
        };
        return _products[handle];
      }
      return null;
    } catch (err) {
      return null;
    }
  }, "getFetchProduct"),
  saveProduct: /* @__PURE__ */ __name((handle, dataOverride = void 0) => {
    _products[handle] = {
      ..._products[handle] ?? {},
      ...dataOverride ?? {}
    };
    if (_products[handle]) {
      const dbKey = `_${window.Shopify.theme.id}-product--${handle}`;
      requestIdleCallback(
        async () => {
          await idbKeyval.set(dbKey, _products[handle]);
        },
        { timeout: 5e3 }
      );
      return _products[handle];
    }
    return null;
  }, "saveProduct"),
  getHydratedProductData: /* @__PURE__ */ __name(async (handle, productId) => {
    if (!_products[handle] || (_products[handle]?.recommendations_loaded_at ?? 0) < Date.now() - 1e3 * 60 * 30) {
      _product2.getHtmlProduct(handle);
    }
    if (!_products[handle] || (_products[handle]?.recommendations_loaded_at ?? 0) < Date.now() - 1e3 * 60 * 30) {
      await _product2.getCachedProduct(handle);
    }
    if (!_products[handle] || (_products[handle]?.recommendations_loaded_at ?? 0) < Date.now() - 1e3 * 60 * 30) {
      if (productId) {
        await _product2.getFetchProduct(handle, productId);
      }
      if (!productId) {
        await _product2.getFetchProduct(handle, productId);
      }
    }
    if (!_products[handle] || (_products[handle]?.recommendations_loaded_at ?? 0) < Date.now() - 1e3 * 60 * 30) {
      return null;
    }
    _product2.saveProduct(handle);
    return _products[handle];
  }, "getHydratedProductData"),
  getProductData: /* @__PURE__ */ __name(async (handle, productId) => {
    if (!_products[handle]) {
      _product2.getHtmlProduct(handle);
    }
    if (!_products[handle]) {
      await _product2.getCachedProduct(handle);
    }
    if (!_products[handle]) {
      await _product2.getFetchProduct(handle, productId);
    }
    if (!_products[handle]) {
      return null;
    }
    _product2.saveProduct(handle);
    return _products[handle];
  }, "getProductData"),
  lastOptions: {}
};
window._product = _product2;
var initProductData = /* @__PURE__ */ __name(() => {
}, "initProductData");

// assets/product-drawer.ts
var initProductDrawer = /* @__PURE__ */ __name(() => {
  window.Alpine.store("productDrawer", {
    show: false,
    product: _products[Object.keys(_products)[0]],
    showProductDrawer({ product = _products[Object.keys(_products)[0]] }) {
      this.product = product;
      this.show = true;
    }
  });
  const productDrawerStore = window.Alpine.store("productDrawer");
  window.Alpine.magic("productDrawer", () => productDrawerStore);
  window._stores["productDrawer"] = productDrawerStore;
}, "initProductDrawer");

// assets/quick-view.ts
var initQuickView = /* @__PURE__ */ __name(() => {
  window.Alpine.store("quickView", {
    show: false,
    loading: false,
    handle: "",
    dynamic_popups: [],
    container: document.querySelector("[data-quick-view-container]"),
    show_all_container: document.querySelector("[data-quick-view-show-more]"),
    loading_container: document.querySelector("[data-quick-view-loading]"),
    async renderQuickView(handle, $data, bundleButton, variantId) {
      const container = this.container;
      this.handle = handle;
      this.show = true;
      this.loading_container.classList.remove("opacity-0", "pointer-events-none");
      if (!handle || !container) return;
      const cacheKey = `${window.location.origin}/products/${handle}`;
      let cache = barba.cache.get(cacheKey);
      if (!cache?.request) {
        const keys = await idbKeyval.keys();
        const key = keys.find((key2) => key2.includes(cacheKey));
        if (key) {
          cache = barba.cache.set(cacheKey, idbKeyval?.get(key)?.then((res) => res?.data), "prefetch");
        }
      }
      if (!cache?.request) {
        const data = fetch(cacheKey, { cache: "force-cache" }).then((res) => res.text()).then((html2) => ({
          html: html2,
          url: { hash: void 0, href: cacheKey, path: `/products/${handle}` }
        }));
        cache = barba.cache.set(cacheKey, data, "prefetch");
        document.dispatchEvent(new CustomEvent("barba:prefetch:fulfilled", { detail: { url: cacheKey } }));
      }
      let request = await cache?.request;
      let html = request?.html;
      if (!html) {
        const data = fetch(cacheKey, { cache: "force-cache" }).then((res) => res.text()).then((html2) => ({
          html: html2,
          url: { hash: void 0, href: cacheKey, path: `/products/${handle}` }
        }));
        cache = barba.cache.set(cacheKey, data, "prefetch");
        request = await cache?.request;
        html = request?.html;
        document.dispatchEvent(new CustomEvent("barba:prefetch:fulfilled", { detail: { url: cacheKey } }));
      }
      const div = document.createElement("div");
      div.innerHTML = html;
      const productData = div.querySelector(`[data-product-data="${handle}"]`);
      div.querySelectorAll("[data-popup]").forEach((popup) => {
        document.body.appendChild(popup);
        this.dynamic_popups.push(popup);
      });
      const section = div.querySelector(`[data-content-root] [data-section-type="product"]`);
      const sideContent = section.querySelector('[x-ref="content"]');
      sideContent.classList.add("max-h-full", "overflow-y-auto");
      section.setAttribute("data-quick-view", "true");
      this.loading_container.classList.add("opacity-0", "pointer-events-none");
      container.innerHTML = productData.outerHTML + section?.outerHTML;
      const stateElement = container.querySelector('[data-section-type="product"]');
      if ($data && bundleButton && stateElement) {
        stateElement.querySelectorAll('[data-block-type="quantity_selector"], [data-block-type="complementary_products"]').forEach((el) => {
          el.remove();
        });
        stateElement.querySelectorAll(`[data-block-type="add_to_cart_button"]`).forEach((element) => {
          const clonedBundleButton = bundleButton.cloneNode(true);
          element.innerHTML = "";
          element.appendChild(clonedBundleButton);
        });
        Alpine.nextTick(() => {
          stateElement._x_dataStack?.forEach((proxyState) => {
            if (proxyState?.card && proxyState?.bundle && proxyState?.state) {
              proxyState.card = proxyState.state;
              proxyState.bundle = $data.bundle;
            }
          });
        });
      }
      if (variantId) {
        Alpine.nextTick(() => {
          stateElement._x_dataStack?.forEach((proxyState) => {
            if (proxyState?.state && proxyState.setSelectedVariant) {
              proxyState.setSelectedVariant(+variantId);
            }
          });
        });
      }
      this.show_all_container.innerHTML = `<button type="button" class="text-black" @click="$quickView.show = false; barba.go('${window.location.origin}/products/${handle}')">Show full details</a>`;
    }
  });
  const quickViewStore = window.Alpine.store("quickView");
  const handleKeydown = /* @__PURE__ */ __name((e) => {
    if (e.key === "Escape") {
      quickViewStore.show = false;
    }
  }, "handleKeydown");
  window.Alpine.effect(() => {
    document.body.classList.toggle("!overflow-hidden", quickViewStore.show);
    if (quickViewStore.show) {
      document.addEventListener("keydown", handleKeydown);
    }
    if (!quickViewStore.show) {
      document.removeEventListener("keydown", handleKeydown);
      quickViewStore.dynamic_popups?.forEach((element) => {
        element.remove();
      });
      quickViewStore.dynamic_popups = [];
    }
  });
  window.Alpine.magic("quickView", () => quickViewStore);
  window._stores["quickView"] = quickViewStore;
}, "initQuickView");

// assets/scrollbar.ts
var initScrollBar = /* @__PURE__ */ __name(() => {
}, "initScrollBar");
var _scrollbar = {
  init: /* @__PURE__ */ __name((bar, thumb, container, scroll_speed = 150) => {
    const findScrollContainer = /* @__PURE__ */ __name((element) => {
      return element?.parentElement?.querySelector('[x-ref="scrollContainer"]') || findScrollContainer(element.parentElement);
    }, "findScrollContainer");
    if (bar && !container) {
      container = findScrollContainer(bar);
    }
    const state = window.Alpine.reactive({
      currentPage: Math.max(
        1,
        Math.min(
          [...container?.children ?? []]?.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).length,
          [...container?.children ?? []]?.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).findIndex((child) => {
            const center = container?.clientWidth / 2 + container?.scrollLeft;
            const start = container?.scrollLeft + +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0");
            if (container?.children.length > Math.round(container?.scrollWidth / container?.clientWidth * 100) / 100) {
              return child.offsetLeft - 5 <= start && child.offsetLeft + child.clientWidth > start;
            }
            return child.offsetLeft < center && child.offsetLeft + child.clientWidth > center;
          }) + 1
        )
      ),
      pages: [...container?.children ?? []]?.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
      ).length,
      width: container?.clientWidth / container?.scrollWidth * 100,
      left: container?.scrollLeft / container?.scrollWidth * bar.clientWidth / bar.clientWidth,
      manual_scroll: false,
      no_next_page: container?.scrollLeft + container?.clientWidth + 25 >= container?.scrollWidth
    });
    const calculatePosition = /* @__PURE__ */ __name(() => {
      const children = [...container?.children ?? []].filter((el) => el.tagName !== "STYLE");
      state.currentPage = Math.max(
        1,
        Math.min(
          children?.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).length,
          children?.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).findIndex((child) => {
            const center = container?.clientWidth / 2 + container?.scrollLeft;
            const start = container?.scrollLeft + +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0");
            if (children.length > Math.round(container?.scrollWidth / container?.clientWidth * 100) / 100) {
              return child.offsetLeft - 5 <= start && child.offsetLeft + child.clientWidth > start;
            }
            return child.offsetLeft < center && child.offsetLeft + child.clientWidth > center;
          }) + 1
        )
      );
      if (container?.scrollLeft + container?.clientWidth + 10 >= container?.scrollWidth) {
        if (container?.scrollWidth - state.currentPage * container?.clientWidth > 20) {
          state.currentPage += 1;
        }
      }
      state.pages = children?.filter((child) => getComputedStyle(child).display !== "none").length;
      state.width = container?.clientWidth / container?.scrollWidth;
      state.left = container?.scrollLeft / container?.scrollWidth * bar.clientWidth / bar.clientWidth;
      state.no_next_page = state.currentPage === state.pages || container?.scrollLeft + container?.clientWidth + 25 >= container?.scrollWidth;
    }, "calculatePosition");
    const handleScrollBarClick = /* @__PURE__ */ __name((e, content_slider) => {
      const percentage = (e.clientX - bar.getBoundingClientRect().left) / bar.clientWidth - state.width / 2 * bar.clientWidth / bar.clientWidth;
      if (content_slider?.state) {
        content_slider.state.block_scroll_events = true;
      }
      container?.scrollTo({
        left: percentage * container?.scrollWidth,
        behavior: "instant"
      });
      if (content_slider?.state) {
        content_slider.state.block_scroll_events = false;
      }
      calculatePosition();
    }, "handleScrollBarClick");
    const handleScrollThumbPointerDown = /* @__PURE__ */ __name((e, content_slider) => {
      if (!container) return;
      container.style.scrollSnapType = "none";
      const startX = e.clientX;
      const startLeft = state.left * bar.clientWidth;
      document.body.classList.add("[&_*]:!cursor-grabbing");
      thumb.classList.add("active");
      if (content_slider?.state) {
        content_slider.state.block_scroll_events = true;
      }
      const handleDocumentPointerMove = /* @__PURE__ */ __name((e2) => {
        const percentage = Math.max(
          0,
          Math.min(1, (startLeft + e2.clientX - startX) / bar.clientWidth)
        );
        container?.scrollTo({
          left: percentage * container?.scrollWidth,
          behavior: "instant"
        });
        calculatePosition();
      }, "handleDocumentPointerMove");
      const handleDocumentPointerUp = /* @__PURE__ */ __name((e2) => {
        removeEventListeners();
      }, "handleDocumentPointerUp");
      const removeEventListeners = /* @__PURE__ */ __name(() => {
        document.body.classList.remove("[&_*]:!cursor-grabbing");
        thumb.classList.remove("active");
        container.style.scrollSnapType = "";
        document.removeEventListener("pointermove", handleDocumentPointerMove);
        document.removeEventListener("pointerup", handleDocumentPointerUp);
        if (content_slider?.state) {
          content_slider.state.block_scroll_events = false;
        }
      }, "removeEventListeners");
      document.addEventListener("pointermove", handleDocumentPointerMove);
      document.addEventListener("pointerup", handleDocumentPointerUp);
    }, "handleScrollThumbPointerDown");
    const handlePrevClick = /* @__PURE__ */ __name((e, content_slider) => {
      if (!container) return;
      container.style.scrollSnapType = "none";
      if (content_slider?.state) {
        content_slider.state.block_scroll_events = true;
      }
      const activeChildren = [...container?.children ?? []]?.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none" && child.tagName !== "STYLE"
      );
      utils.scrollToX(
        scroll_speed,
        (activeChildren[Math.max(
          0,
          state.currentPage - 2 < 0 ? activeChildren?.length - 1 : state.currentPage - 2
        )]?.offsetLeft ?? 0) - +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0"),
        container,
        () => {
          container.style.scrollSnapType = "";
          calculatePosition();
          if (content_slider?.state) {
            content_slider.state.block_scroll_events = false;
          }
        }
      );
    }, "handlePrevClick");
    const handleNextClick = /* @__PURE__ */ __name((e, content_slider) => {
      if (!container) return;
      container.style.scrollSnapType = "none";
      if (content_slider?.state) {
        content_slider.state.block_scroll_events = true;
      }
      const activeChildren = [...container?.children ?? []]?.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none" && child.tagName !== "STYLE"
      );
      utils.scrollToX(
        scroll_speed,
        (activeChildren[Math.min(
          activeChildren.length - 1,
          state.currentPage === activeChildren?.length ? 0 : state.currentPage
        )]?.offsetLeft ?? 0) - +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0"),
        container,
        () => {
          container.style.scrollSnapType = "";
          calculatePosition();
          if (content_slider?.state) {
            content_slider.state.block_scroll_events = false;
          }
        }
      );
    }, "handleNextClick");
    if (container) {
      container.onscroll = (e) => {
        calculatePosition();
      };
    }
    const mutationObserver = new MutationObserver((e) => {
      calculatePosition();
    });
    mutationObserver.observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
    const resizeObserver = new ResizeObserver((e) => {
      calculatePosition();
    });
    resizeObserver.observe(container, { box: "content-box" });
    calculatePosition();
    return {
      handleScrollBarClick,
      handleScrollThumbPointerDown,
      handlePrevClick,
      handleNextClick,
      scrollbar: state,
      containerRef: container
    };
  }, "init")
};
window._scrollbar = _scrollbar;

// assets/smooth-scroll.ts
var initSmoothScroll = /* @__PURE__ */ __name(() => {
  const elements = /* @__PURE__ */ new Set();
  const scrollToElementByTargetId = /* @__PURE__ */ __name((id) => {
    let target = document.getElementById(id);
    if (!target) {
      return;
    }
    if (utils.isElementScrollable(target.parentElement) && utils.isVisible(target.parentElement) && utils.isInViewport(target)) {
      if (target.parentElement.scrollWidth > target.parentElement.offsetWidth) {
        utils.scrollToXY(
          260,
          target.offsetLeft,
          target.parentElement?.scrollTop,
          target.parentElement
        );
      }
      if (target.parentElement.scrollHeight > target.parentElement.offsetHeight) {
        utils.scrollToXY(
          260,
          target.parentElement?.scrollLeft,
          target.offsetTop,
          target.parentElement
        );
      }
      return;
    }
    if (target.hasAttribute("data-tab-id")) {
      target = target.closest(".shopify-section");
    }
    const targetPosition = utils.getElementPosition(target)?.top - Math.max(
      0,
      document.querySelector(".header-sections-container")?.getBoundingClientRect()?.bottom ?? 0
    );
    utils.scrollToY(
      260 + Math.min(Math.abs(Math.round((window.scrollY - targetPosition) / 15)), 500),
      targetPosition
    );
  }, "scrollToElementByTargetId");
  const initEvents = /* @__PURE__ */ __name((target = document) => {
    const links = target.querySelectorAll(
      `[href*="#"]:not([href*="#modal--"], [href*="#popup--"], [href*="#drawer--"], use)`
    );
    links.forEach((link) => {
      if (typeof link.href !== "string") {
        return;
      }
      if (elements.has(link)) {
        return;
      }
      elements.add(link);
      if (utils.isExternalURL(link.href)) {
        return;
      }
      const id = link?.href?.split("#")?.at(1)?.split(/[?&]/)?.at(0);
      const target2 = document.getElementById(id);
      if (!target2) {
        return;
      }
      link.onclick = () => {
        scrollToElementByTargetId(id);
      };
    });
  }, "initEvents");
  const mutationObserver = new MutationObserver((e) => {
    e?.forEach((record) => {
      const nodes = [];
      if (record?.addedNodes?.length && record?.target instanceof Element) {
        initEvents(record.target);
      }
    });
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  if (window.location.hash) {
    scrollToElementByTargetId(window.location.hash.replace(/#/gi, ""));
  }
  initEvents();
}, "initSmoothScroll");

// assets/toast.ts
var initToast = /* @__PURE__ */ __name(() => {
  window.Alpine.store("toast", {
    toasts: [],
    paused: false,
    interval: null,
    addToast: /* @__PURE__ */ __name(function({
      type = "plain",
      target = "generic",
      timestamp = Date.now(),
      title,
      content,
      icon,
      hide = 0
    }) {
      const defaultIcon = {
        plain: "bolt",
        warning: "warning-triangle",
        error: "error-circle",
        info: "info-circle",
        success: "check-circle"
      }[type];
      this.toasts.push({
        type,
        target,
        timestamp,
        title,
        content,
        icon: icon || defaultIcon,
        hide
      });
      this.toasts = this.toasts.filter(
        (a, i, arr) => arr.findIndex((b) => a.title === b.title && a.content === b.content) === i
      );
    }, "addToast"),
    removeAllToasts: /* @__PURE__ */ __name(function() {
      this.toasts = [];
    }, "removeAllToasts"),
    pauseRemoval: /* @__PURE__ */ __name(function() {
      this.paused = true;
      clearInterval(this.interval);
      this.interval = null;
    }, "pauseRemoval"),
    continueRemoval: /* @__PURE__ */ __name(function() {
      this.paused = false;
    }, "continueRemoval")
  });
  const toastStore = window.Alpine.store("toast");
  window.Alpine.magic("toast", () => toastStore);
  window.Alpine.effect(() => {
    if (toastStore.toasts.length && !toastStore.interval && !toastStore.paused) {
      toastStore.interval = setInterval(() => {
        const checkTimestamp = Date.now() - 3e3;
        toastStore.toasts = toastStore.toasts.map((toast) => ({
          ...toast,
          hide: toast.timestamp < checkTimestamp ? Date.now() : 0
        }));
        if (toastStore.toasts.every((toast) => toast.hide && toast.hide > 500)) {
          toastStore.toasts = [];
        }
      }, 500);
    }
    if (toastStore.interval && !toastStore.toasts.length) {
      clearInterval(toastStore.interval);
      toastStore.interval = null;
    }
  });
  window._stores["toast"] = toastStore;
}, "initToast");

// assets/tooltip.ts
var initTooltip = /* @__PURE__ */ __name(() => {
  const container = document.querySelector("[data-tooltip-container]");
  window.Alpine.store("tooltip", {
    tooltips: /* @__PURE__ */ new Map(),
    async addTooltip(element, content, position = "top") {
      const currentTooltip = this.tooltips.get(element);
      if (!currentTooltip) {
        const parents = utils.findAllScrollableParents(element);
        const tooltipElement = document.createElement("div");
        tooltipElement.innerHTML = content;
        const handleUpdateCoordinates = /* @__PURE__ */ __name(() => {
          const { top, left, right, width, height, bottom } = element.getBoundingClientRect();
          tooltipElement.classList.add("active");
          if (position === "top") {
            tooltipElement.style.top = `${top}px`;
            tooltipElement.style.left = `${left + width / 2}px`;
          }
          if (position === "bottom") {
            tooltipElement.style.top = `${bottom}px`;
            tooltipElement.style.left = `${left + width / 2}px`;
          }
          if (position === "left") {
            tooltipElement.style.top = `${top + height / 2}px`;
            tooltipElement.style.left = `${left}px`;
          }
          if (position === "right") {
            tooltipElement.style.top = `${top + height / 2}px`;
            tooltipElement.style.left = `${right}px`;
          }
        }, "handleUpdateCoordinates");
        this.tooltips.set(element, {
          tooltip: tooltipElement,
          timeout: null,
          handleUpdateCoordinates,
          scrollParents: parents
        });
        container.appendChild(tooltipElement);
        tooltipElement.classList.add("tooltip", `tooltip--${position}`);
        await utils.delay(1);
        handleUpdateCoordinates();
        parents.forEach((parent) => {
          parent.addEventListener("scroll", handleUpdateCoordinates);
        });
      }
      if (currentTooltip) {
        clearTimeout(currentTooltip.timeout);
        currentTooltip.timeout = null;
      }
    },
    async removeTooltip(element) {
      const currentTooltip = this.tooltips.get(element);
      if (currentTooltip) {
        const tooltip = currentTooltip.tooltip;
        currentTooltip.timeout = setTimeout(async () => {
          tooltip.classList.remove("active");
          this.tooltips.delete(element);
          tooltip.ontransitionend = (event) => {
            tooltip.remove();
          };
        }, 50);
      }
    }
  });
  const tooltipStore = window.Alpine.store("tooltip");
  window.Alpine.magic("tooltip", () => tooltipStore);
  window._stores["tooltip"] = tooltipStore;
}, "initTooltip");

// assets/theme.ts
window.utils = utils_default;
document.dispatchEvent(new CustomEvent("theme:utils:loaded"));
(() => {
  window.onerror = function(...args) {
    return args?.[0] === "Script error.";
  };
  window.onunhandledrejection = function(event) {
    console.warn("\u{1F6A8} Unhandled Promise Rejection:", event.reason);
  };
  const origConsoleWarn = console.warn;
  window.console.warn = function(...args) {
    if (args?.[0]?.includes("Alpine Expression Error")) {
      const [message, ...rest] = args;
      console.error(
        `%cAlpine JS Error:%c 

${message?.replaceAll("\n\n", "\n")}
`,
        "color: red; font-size: 17px; font-weight: 600;",
        "font-weight: 600; font-size: 14px;",
        ...rest
      );
      return;
    }
    return origConsoleWarn.apply(this, args);
  };
})();
var initTheme = /* @__PURE__ */ __name(() => {
  if (!window.location.origin.includes("127.0.0.1") && Shopify.theme.role === "main") {
    console.log(
      "%cHEY YOU! I see you peeking into the code. This Theme is custom built by Platter.com. This site is powered Alpine.JS, Tailwind CSS & TypeScript integrated into Shopify using our proprietary development tools. https://www.platter.co/",
      "background: rgb(0,0,0);color: #fafafa;font-size: 24px;font-weight: bold;padding: 16px 10px;text-align: center;text-shadow: 2px 2px 0 rgba(45, 45, 45);"
    );
    console.log(
      "%cWe are constantly looking for talented developers. If you have Shopify theme development experience under your belt and are keen to explore an exciting tech stack in a fast paced environment. Contact us at engineering@platter.com",
      "background: rgb(0,0,0);color: #fafafa;font-size: 24px;font-weight: bold;padding: 16px 10px;text-align: center;text-shadow: 2px 2px 0 rgba(45, 45, 45);"
    );
  }
  window.Alpine.store("editor", {
    load_section_id: "",
    unload_section_id: "",
    select_section_id: "",
    reorder_section_id: "",
    select_block_id: "",
    inspector: false,
    setValue(key, value) {
      this[key] = value;
    }
  });
  const editor = window.Alpine.store("editor");
  window.Alpine.magic("editor", () => editor);
  initModals();
  initAccessibility();
  initQuickView();
  initProductDrawer();
  initCart();
  initProductData();
  initScrollBar();
  initTooltip();
  initToast();
  initSearch();
  initMediaGallery();
  initSmoothScroll();
  initPageTransitions();
  initPagination();
  if (window.design_mode) {
    document.dispatchEvent(new CustomEvent("theme:editor:init"));
  }
  document.dispatchEvent(new CustomEvent("theme:init"));
}, "initTheme");
document.addEventListener("alpine:init", initTheme);
export {
  initTheme
};

// random_comment  